<template>
  <a-form class="form" layout="vertical" ref="formRef" :model="formState" :rules="rules">
    <section class="container" id="create-strategy-page">
      <a-button
        class="back-button"
        type="link"
        aria-label="Close"
        @click="handleCancel"
      >
        <LeftOutlined class="icon-arrowleft" />
        <span>Volver</span>
      </a-button>
      <h2 class="container__title">Importa tu plantilla para generar una estrategia</h2>
      <custom-scrollbar class="container__body" id="create-strategy-form" height="100%">
        <div class="card">
          <a-row :gutter="24">
            <a-col :span="11">
              <a-form-item label="Nombre de estrategia" name="name">
                <a-input v-model:value="formState.name" placeholder="Escribir aquí" />
              </a-form-item>
            </a-col>
            <a-col :span="13">
              <a-form-item label="Tipo de estrategia" name="strategy_category">
                <a-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  :value="formState.strategy_category"
                  placeholder="Seleccione una estrategia"
                  @change="handleTypeStrategyChange"
                >
                  <a-select-option v-for="item in strategyTypes" :key="item.id">
                    <span>{{ item.name }}</span>
                    <a-tag 
                      v-if="item.action"
                      style="margin-left: 10px"
                      :color="ActionPlanStrategyColor[item.action]">
                      {{ ActionPlanStrategyText[item.action] }}
                    </a-tag>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="formState.strategy_category === StrategyType.ivr" :gutter="24">
            <a-col :span="11">
              <a-form-item label="Tipo de IVR" name="type_strategy">
                <a-select
                  :value="formState.type_strategy"
                  placeholder="Seleccionar tipo de IVR"
                  @change="handleIvrTypeChange"
                >
                  <a-select-option v-for="item in ivrTypes" :key="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <div
            class="info-help"
            v-if="seletedStrategy && currentStrategyHelp"
          >
            <p class="info-help__text">
              {{ currentStrategyHelp.text }}
              Conoce más haciendo
              <a :href="currentStrategyHelp.url" target="_blank" rel="noopener noreferrer">click aquí</a>.
            </p>
          </div>
        </div>

        <div class="card--error" v-if="typeStrategy === 6 && isEmailSuspended">
          <CloseCircleFilled class="error__icon" />
          <p class="error__text">
            Su empresa ha sido suspendida para el envío de correos masivos debido a las altas tasas
            de rebotes duros y/o quejas de spam.
          </p>
          <a-button @click="openEmailModalSuspension = true"> Conocer más </a-button>
        </div>

        <div class="container__empty" v-if="!seletedStrategy">
          <p class="message--info">Selecciona el tipo de estrategia que deseas gestionar</p>
          <p class="message--info">para mostrar los campos correspondientes</p>
        </div>

        <section v-if="seletedStrategy">
          <div class="card">
            <a-row :gutter="typeStrategy == TypeStrategy.Predictive ? '24' : '16'">
              <a-col :span="typeStrategy == TypeStrategy.Predictive ? '12' : '8'" v-if="!isTypeBusiness">
                <a-form-item label="Empresa" name="entity">
                  <a-select
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    :dropdownRender="renderWheelSafeDropdown"
                    v-model:value="formState.entity"
                    placeholder="Seleccione una empresa"
                    @change="handleEntityChange"
                  >
                    <a-select-option v-for="item in entities" :key="item.id">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="typeStrategy == TypeStrategy.Predictive ? '12' : '8'">
                <a-form-item label="Campaña" name="portfolio">
                  <a-select
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    :dropdownRender="renderWheelSafeDropdown"
                    v-model:value="formState.portfolio"
                    placeholder="Seleccione una campaña"
                    @change="handlePortfolioChange"
                    :disabled="typeStrategy === 6 && isEmailSuspended"
                  >
                    <a-select-option
                      v-for="item in portfolios"
                      :key="item.id"
                      :disabled="isVoiceStrategy ? !item.voip_provider : false"
                    >
                      {{ item.name }}
                      <template v-if="isVoiceStrategy">
                        {{ !item.voip_provider ? " (Sin troncal)" : "" }}
                      </template>
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8" v-if="typeStrategy === 6">
                <a-form-item name="channel_customer">
                  <template #label>
                    Dirección del remitente

                    <a-popover>
                      <template #content>
                        <div class="info-popover-wrapper">
                          <p>Ingresar dirección del remitente</p>
                        </div>
                      </template>

                      <InfoCircleOutlined style="margin-left: 5px" />
                    </a-popover>
                  </template>
                  <a-select
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    v-model:value="selectedEmailOption"
                    placeholder="Seleccionar dirección"
                    :disabled="typeStrategy === 6 && isEmailSuspended"
                    @change="handleEmailOptionChange"
                  >
                    <template v-for="item in emailIdentifiers" :key="item.id">
                      <a-select-option :value="'id:' + item.id">
                        <div class="option">
                          <span>{{ item.associate }}</span>
                          <p>{{ item.alias }}</p>
                        </div>
                      </a-select-option>
                      <a-select-option
                        v-for="alias in getAliasesForChannel(item.id)"
                        :key="'alias-' + alias.email"
                        :value="'alias:' + item.id + ':' + alias.email"
                      >
                        <div class="option">
                          <span>{{ alias.email }}</span>
                          <p>{{ item.alias }} ({{ item.associate }})</p>
                        </div>
                      </a-select-option>
                    </template>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8" v-if="typeStrategy === 6">
                <a-form-item name="messageType" label="Tipo de mensaje">
                  <a-select
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    v-model:value="formState.email_type"
                    placeholder="Seleccionar tipo"
                    @change="handleEmailTypeChange"
                    @update:value="getEmailTemplates"
                    :disabled="typeStrategy === 6 && isEmailSuspended"
                  >
                    <a-select-option :key="1">Usar plantilla</a-select-option>
                    <a-select-option :key="2">Redactar correo</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8" v-if="typeStrategy === 6">
                <a-form-item name="email_type_send" label="Horario de envío">
                  <a-select
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    v-model:value="formState.email_type_send"
                    placeholder="Seleccionar horario"
                    @change="handleEmailTimeChange"
                    :disabled="typeStrategy === 6 && isEmailSuspended"
                  >
                    <a-select-option :key="1">Elegir de forma manual</a-select-option>
                    <a-select-option :key="2">Programar horario</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="Base" name="base" v-if="user?.customer.enable_bases">
                  <a-select
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    v-model:value="formState.base"
                    placeholder="Seleccione una base"
                    @change="handleChangeInput"
                  >
                    <a-select-option v-for="item in bases" :key="item.id">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="typeStrategy == TypeStrategy.Predictive ? '24' : '16'">
              <a-col :span="typeStrategy == TypeStrategy.Predictive ? '12' : '8'" v-if="typeStrategy != 3 && typeStrategy != 5 && typeStrategy != 6">
                <TypeAssignmentPicker
                  name="type_assignment"
                  label="Tipo de asignación"
                  popoverTitle="Tipo de asignación"
                  v-model="formState.type_assignment"
                  :disabled="typeStrategy !== 2"
                  :show-upload-criteria="typeStrategy === TypeStrategy.Progressive"
                  :options="[
                    { value: 1, label: 'Aleatorio' },
                    { value: 2, label: 'Por asignación' }
                  ]"
                  @open-upload-criteria="openUploadCriteria"
                >
                </TypeAssignmentPicker>
              </a-col>

              <a-col :span="8" v-if="[5, strategyType.createTemplateBySms].includes(typeStrategy)">
                <QueuePicker
                  label="Cola"
                  v-model:value="formState.queue"
                  @update:value="getTemplates"
                  :portfolio="formState.portfolio"
                  :showAll="false"
                  :withOutPortfolio="false"
                />
              </a-col>

              <a-col :span="8" v-if="strategyType.createTemplateBySms === typeStrategy">
                <a-form-item name="message_type" label="Tipo de mensaje" required>
                  <a-select
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    v-model:value="formState.message_type"
                    placeholder="Seleccionar tipo de mensaje"
                    @change="handleChangeOpenSms"
                  >
                    <a-select-option key="template">Usar plantilla</a-select-option>
                    <a-select-option key="write">Redactar mensaje</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :span="8" v-if="[5, strategyType.createTemplateBySms].includes(typeStrategy)">
                <a-form-item name="destination">
                  <template #label>
                    Destino

                    <a-popover title="Destino">
                      <template #content>
                        <div class="info-popover-wrapper">
                          <p>
                            Hace referencia al tipo de persona a la que se enviará la plantilla.
                          </p>

                          <p>
                            <strong>Contactos existente: </strong> Personas que se encuentran
                            registradas como contactos en {{ ProductName }}.
                          </p>

                          <p>
                            <strong>Números externos: </strong> Personas que actualmente no se
                            encuentran registradas en {{ ProductName }}. Podrás guardarlas como
                            contactos en el momento en el que respondan tu mensaje.
                          </p>
                        </div>
                      </template>
                      <InfoCircleOutlined style="margin-left: 5px" />
                    </a-popover>
                  </template>

                  <a-select
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    v-model:value="formState.destination"
                    placeholder="Seleccionar destino"
                    @change="
                      formState.type_strategy === StrategyType.whatsapp
                        ? handleChangeOpenWhatsapp()
                        : null
                    "
                  >
                    <a-select-option :key="1">Contactos existentes</a-select-option>
                    <a-select-option :key="2">Números externos</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :span="typeStrategy == TypeStrategy.Predictive ? '12' : '8'" v-if="typeStrategy === StrategyType.predictive">
                <a-form-item
                  name="predictive_time"
                  label="Horario de inicio"
                  :rules="[{ required: true, message: 'Campo requerido' }]"
                >
                  <a-select
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    v-model:value="formState.predictive_time"
                    placeholder="Seleccionar horario"
                    @change="handlePredictiveTimeChange"
                  >
                    <a-select-option :key="1">
                      <a-tooltip
                        overlayClassName="white-tooltip"
                        placement="right"
                      >
                        <template #title>
                          Una vez creada la estrategia podrás <br/>
                          decidir cuando ejecutarla presionando el botón iniciar.
                        </template>
                        <div>Iniciar de forma manual</div>
                      </a-tooltip>
                    </a-select-option>
                    <a-select-option :key="2">Programar horario</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-alert 
              v-if="formState.type_assignment == TypeAssignment.AssignedUser && typeStrategy == StrategyType.progressive"
              style="margin-bottom: 12px" 
              type="warning" 
              show-icon 
            >
              <template #message>
                Solo se cargarán los contactos con un usuario asignado. Si aún no tienen uno, puedes asignarlos desde Importaciones con la plantilla Asignación de usuarios. 
                <a-button style="height: auto; padding: 0;" type="link" @click="openUploadCriteria">Conocer más</a-button>
              </template>
            </a-alert>

            <a-alert
              v-if="formState.type_strategy === StrategyType.predictive && formState.portfolio"
              style="margin-bottom: 12px"
              type="warning"
              show-icon
            >
              <template #message>
                Para estrategias de tipo predictivo, la campaña debe tener configurada equivalentes para el grupo “No contacto”. Puedes realizarlo ahora en 
                <a-button
                  type="link"
                  style="height: auto; padding: 0"
                  @click="handleNavigateToTypifications"
                >
                  Tipificaciones
                </a-button>
                o después de generar la estrategia.
              </template>
            </a-alert>  

          </div>
          <section v-if="(typeStrategy === 6 && emailTime === 2) || (typeStrategy === StrategyType.predictive && predictiveTime === 2)">
            <div class="card">
              <h4>Programar horario</h4>
              <a-row :gutter="16">
                <a-col :span="8">
                  <a-form-item
                    name="execution_time"
                    label="Seleccionar fecha"
                    :rules="typeStrategy === StrategyType.predictive ? executionTimeRules : []"
                  >
                    <a-date-picker
                      style="width: 100%"
                      v-model:value="formState.execution_time"
                      :format="humanDateFormat"
                      v-bind:item="value"
                      class="picker"
                      placeholder="Seleccionar fecha"
                      :show-today="false"
                      :disabled-date="disabledDate"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item
                    name="execution_time"
                    label="Seleccionar hora"
                    :rules="typeStrategy === StrategyType.predictive ? executionTimeRules : []"
                  >
                    <a-time-picker
                      v-model:value="formState.execution_time"
                      v-bind:item="value"
                      placeholder="Seleccionar hora"
                      format="HH:mm"
                      class="picker"
                      style="width: 100%"
                      :disabled-time="() => disabledTime(formState.execution_time)"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
            </div>
          </section>
          <section v-if="typeStrategy === 6">
            <div class="card">
              <h4>Asunto</h4>
              <a-form-item label="Línea del asunto" name="subject">
                <a-input
                  v-model:value="formState.subject"
                  placeholder="Escribir asunto"
                  show-count
                  :maxlength="120"
                  :disabled="typeStrategy === 6 && isEmailSuspended"
                />
              </a-form-item>
              <a-form-item label="Texto de vista previa (opcional)" name="message_preview">
                <a-input
                  v-model:value="formState.message_preview"
                  placeholder="Escribir vista previa"
                  show-count
                  :maxlength="150"
                  :disabled="typeStrategy === 6 && isEmailSuspended"
                />
              </a-form-item>
              <p>
                Controla el texto de vista previa que aparece en la mayoría de las bandejas de
                entrada.
              </p>
            </div>
          </section>
          <!-- Opciones redactar correo correo masivo -->
          <template v-if="openEmail && emailType === 2">
            <div class="card email">
              <h4>Cuerpo del correo electrónico</h4>
              <p class="message--info">
                Escriba el texto de su correo electrónico.
              </p>
              <div class="editor">
                <EditorComponent v-model="formState.message" />
                <InputActionButtons v-model:files="attachments" @select-emoji="handleAddEmoji" multiple :validatePerType="false" />
              </div>
            </div>
          </template>
          <!--Opcion Correo plantilla -->
          <template v-if="emailType === 1 && openEmail">
            <div class="card">
              <h4>Plantilla de correo</h4>
              <a-row :gutter="16">
                <a-col :span="18">
                  <a-form-item label="Selecciona la plantilla de correo" name="template_email">
                    <a-select
                      :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                      v-model:value="formState.template_email"
                      placeholder="Seleccionar plantilla"
                      @change="handleEmailTemplateChange"
                      :option-label-prop="'customLabel'"
                    >
                      <a-select-opt-group v-if="emailTemplatesWithParameters.length > 0" label="Plantillas con parámetros">
                        <a-select-option
                          v-for="item in emailTemplatesWithParameters"
                          :key="item.id.toString()"
                          :disabled="item.status !== 1"
                          :customLabel="`${item.name} (con parámetros)`"
                        >
                          {{ item.name }} ({{ Number(item?.template_type) === TemplateType.Default
                            ? `${ProductName}`
                            : "HTML" }})
                        </a-select-option>
                      </a-select-opt-group>
                      <a-select-opt-group v-if="emailTemplatesWithoutParameters.length > 0" label="Plantillas sin parámetros">
                        <a-select-option
                          v-for="item in emailTemplatesWithoutParameters"
                          :key="item.id.toString()"
                          :disabled="item.status !== 1"
                          :customLabel="`${item.name} (sin parámetros)`"
                        >
                          {{ item.name }} ({{ Number(item?.template_type) === TemplateType.Default
                            ? `${ProductName}`
                            : "HTML" }})
                        </a-select-option>
                      </a-select-opt-group>
                      <!-- <a-select-option
                        v-for="item in emailTemplates"
                        :key="item.id"
                        :disabled="item.status !== 1"
                      >
                        {{ item.name }}
                      </a-select-option> -->
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-popover
                    v-if="displayEmailTemplate && formState.template_email"
                    arrowPointAtCenter
                    placement="right"
                  >
                    <template #content>
                      <iframe
                        :srcdoc="displayEmailTemplate"
                        id="template_email"
                        title="template_email"
                        ref="iframe"
                        style="border: none; width: 700px; height: 500px"
                        @load="scaleIframeContent"
                      ></iframe>
                    </template>
                    <a-button type="link" class="view-template">
                      Previsualiza tu plantilla
                    </a-button>
                  </a-popover>
                  <div v-else class="view-template-disabled">
                    <a-tooltip title="Selecciona una plantilla para poder visualizarlo">
                      <span>
                        Previsualiza tu plantilla
                        <InfoCircleOutlined />
                      </span>
                    </a-tooltip>
                  </div>
                </a-col>
              </a-row>
            </div>
            <div class="card" v-if="templateType !== WhatsappTemplateTypes.Text">
              <h4>
                Carga tu {{ getTemplateTypeText(templateType)?.split(" ")?.at(-1) || "archivo" }}
              </h4>
              <div class="card card--light info">
                <InfoCircleOutlined class="container-file" />
                <span class="info--text">
                  Recuerda que solo podrás adjuntar un único archivo. Este será enviado junto al
                  texto de la plantilla.
                </span>
              </div>
              <div class="container__archive">
                <archive-picker
                  v-model:value="templateFile"
                  @update:value="handleChangeInput"
                  :supported-types="supportedTypes"
                  :maxMBSize="maxMBSize"
                />
              </div>
            </div>

            <div class="card" v-if="formState.template">
              <a-spin :spinning="loadingTemplateLimit">
                <header class="download-header">
                  <h4 style="margin: 0">Carga tus teléfonos y variables</h4>

                  <a-button type="primary" ghost size="small" @click="handleDownloadTemplate">
                    Descargar plantilla

                    <DownloadOutlined />
                  </a-button>
                </header>
                <div
                  v-if="!loadingTemplateLimit"
                  class="card card--light info"
                  :class="{ warning: !remainingTemplateMessages }"
                >
                  <InfoCircleOutlined class="container-file" />
                  <span class="info--text" action="Cerrar">
                    <template v-if="remainingTemplateMessages">
                      Tienes disponible para enviar un máximo de
                      <strong>{{ remainingTemplateMessages }} plantillas</strong> desde tu
                      identificador {{ currentTemplate?.channel_customer?.associate }} según tu
                      <a
                        href="https://developers.facebook.com/docs/whatsapp/messaging-limits/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        TIER.
                      </a>
                    </template>

                    <template v-else>
                      Llegaste a tu límite de envío de mensajes de plantillas disponible según tu en
                      <a
                        href="https://developers.facebook.com/docs/whatsapp/messaging-limits/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        TIER.
                      </a>
                      tu identificador {{ currentTemplate?.channel_customer?.associate }}.
                    </template>
                  </span>
                </div>
                <div class="container__archive">
                  <archive-picker
                    v-model:value="file"
                    @update:value="handleChangeInput"
                    :maxMBSize="3"
                  ></archive-picker>
                </div>
              </a-spin>
            </div>
          </template>
          <template v-if="formState.template_email || formState.email_type === 2">
            <!-- Cargar correos -->
            <div class="card">
              <h4 v-if="formState.email_type === 1 && currentEmailTemplate()">
                {{
                  currentEmailTemplate()?.parameters?.length > 0
                    ? `Plantilla con parámetros: `
                    : `Plantilla sin parámetros`
                }}
                <span class="template_detail">
                  {{ customLabel(currentEmailTemplate()) }}
                </span>
              </h4>
              <div v-if="currentEmailTemplate()?.parameters?.length > 0" style="margin-bottom: 20px">
                <a-form-item
                  style="margin-bottom: 16px"
                  label="Tipo de carga"
                >
                  <a-select
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    v-model:value="formState.type_upload"
                  >
                    <a-select-option v-for="option in chargesType" :key="option.value">
                      {{ option.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
                <template-parameters
                  v-if="formState.type_upload == TypeCharge.PersonalizedParameters"
                  v-model:values="formState.parameters_values"
                  hideTitle
                  :form="formRef"
                  :template="currentEmailTemplate()"
                  :portfolioId="formState.portfolio"
                  :description="`Personalice los parámetros ingresando un valor manualmente o seleccionando un atributo del contacto. Esto te permite ajustar fácilmente la configuración según tus necesidades específicas.`"
                  inStrategy
                />
              </div>
              <a-spin :spinning="false">
                <header class="download-header">
                  <h4 style="margin: 0">
                    Carga tus correos <span v-if="emailType === 1">y variables</span>
                  </h4>
                  <a-tooltip
                    title="Conoce los criterios que tu archivo debe cumplir para cargar tus contacto con éxito."
                  >
                    <a-button class="card__action" type="link" @click="openUploadCriteria">
                      <img class="card__icon" :src="fileCheck" alt="Criterios de carga" />
                      Ver criterios de carga
                    </a-button>
                  </a-tooltip> 
                </header>
                <div class="card card--light info">
                  <InfoCircleOutlined class="container-file" />
                  <span class="info--text" action="Cerrar">
                    Revisa los criterios de carga antes de subir tu archivo. Además, recuerda que para envíos masivos de correos, se requiere el 
                    <strong font-weight="600">consentimiento explícito</strong> de tus suscriptores o contactos.
                  </span>
                </div>
                <div class="container__archive-divider">
                  <a-button type="primary" ghost size="small" @click="handleDownloadEmailTemplate">
                    <DownloadOutlined /> <br/>
                    Descargar plantilla
                  </a-button>
                  <archive-picker
                    v-model:value="file"
                    @update:value="handleChangeInput"
                    :empty-text="plan === PlanSpecial ? 'Arrastra tu archivo aquí' : `Máximo ${maxContactsStrategy} filas`"
                  ></archive-picker>
                </div>
              </a-spin>
            </div>
          </template>
          <!-- Opciones segun correo masivo -->
          <div
            class="container__empty"
            v-if="formState.email_type === 1 && displayEmailTemplate === ''"
          >
            <p class="message--info">Selecciona tu plantilla para continuar con tu importación</p>
            <p class="message--info">de correos y variables (si los tuviera) de la plantilla</p>
          </div>
          <div class="container__empty" v-else-if="typeStrategy === 6 && emailType === 2 && !file">
            <p class="message--info">Selecciona los campos para continuar</p>
            <p class="message--info">con la creación de tu estrategia</p>
          </div>

          <div v-if="typeStrategy === 5 && !openWhatsapp" class="selected__destination">
            <p class="message--info">
              Selecciona la cola y el destino de tus plantillas de WhatsApp
            </p>
            <p class="message--info">para continuar con tu importación</p>
          </div>

          <!--Opcion IVR e IVR Return audio y/o text to speech-->

          <!-- <a-form-item
            v-if="[TypeStrategy.IvrReturn, TypeStrategy.Ivr].includes(typeStrategy)" 
            name="audio_ivr_return"
          >
            <audio-ivr-picker
              :typeStrategy="typeStrategy"
              v-model:audioIvr="formState.audio_ivr_return"
            />
          </a-form-item> -->

          <div
            class="card"
            v-if="[TypeStrategy.IvrReturn, TypeStrategy.Ivr].includes(typeStrategy)"
          >
            <h4>Configuración de audio</h4>
            <p class="message--info">
              Elige el método para definir el audio que escuchará el cliente.
            </p>

            <div style="margin: 10px 0; display: flex; align-items: center; gap: 1px">
              <a-radio-group
                :value="formState.audio_config_type"
                @change="handleAudioConfigTypeChange"
              >
                <a-radio value="upload">Audio propio</a-radio>
                <a-radio value="tts" :disabled="!accessIvr">
                  Generar con Text To Speech
                  <a-tooltip title="Genera el audio para tu IVR en base a un texto.">
                    <InfoCircleOutlined />
                  </a-tooltip>
                </a-radio>
              </a-radio-group>
              <a-button
                v-if="!accessIvr"
                style="padding: 0; margin-left: -10px"
                type="link"
                @click="handleOpenRestrictionTTS"
              >
                <a-tag :color="ActionPlanStrategyColor[ActionPlanStrategy.Upgrade]">
                  {{ ActionPlanStrategyText[ActionPlanStrategy.Upgrade] }}
                </a-tag>
              </a-button>
            </div>
          </div>

          <template
            v-if="
              [TypeStrategy.IvrReturn, TypeStrategy.Ivr].includes(typeStrategy) &&
              formState.audio_config_type === 'upload'
            "
          >
            <a-form-item name="audio_ivr_return">
              <audio-ivr-picker
                :typeStrategy="typeStrategy"
                v-model:audioIvr="formState.audio_ivr_return"
              />
            </a-form-item>
          </template>

          <div
            class="card"
            v-if="
              [TypeStrategy.IvrReturn, TypeStrategy.Ivr].includes(typeStrategy) &&
              formState.audio_config_type === 'tts'
            "
          >
            <h4>Generar con Text To Speech</h4>
            <p class="message--info">
              Escribe el texto que el sistema convertirá en audio. Puedes agregar hasta 5 variables para personalizarlo.
            </p>

            <a-row :gutter="16">
              <a-col :span="8">
                <a-form-item label="Proveedor">
                  <a-select v-model:value="formState.tts_provider">
                    <a-select-option
                      v-for="provider in ttsProviders"
                      :key="provider.value"
                      :value="provider.value"
                    >
                      {{ provider.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :span="8">
                <a-form-item label="Modelo">
                  <a-select v-model:value="formState.tts_model">
                    <a-select-option
                      v-for="model in ttsModels"
                      :key="model.value"
                      :value="model.value"
                    >
                      {{ model.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :span="8">
                <a-form-item label="Tipo de voz">
                  <a-select v-model:value="formState.tts_voice_type">
                    <a-select-option
                      v-for="voice in ttsVoiceTypes"
                      :key="voice.value"
                      :value="voice.value"
                    >
                      {{ voice.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>

            <a-form-item
              class="audio-text"
              name="tts_text"
              style="margin-bottom: 0"
              :validate-status="showTtsRepeatedVariables && hasTtsRepitedVariables ? 'error' : undefined"
              :help="showTtsRepeatedVariables && hasTtsRepitedVariables ? 'Tienes variables repetidas. Usa un nombre distinto para cada una.' : undefined"
            >
              <template #label>
                Texto a convertir en audio
                <a-tooltip overlayClassName="white-tooltip audio-tts-tooltip" placement="right">
                  <template #title>
                    <p>
                      Escribe el texto que se convertirá en audio. Para ingresar variables usa
                      <strong>&#123;&#123; &#125;&#125;</strong> y usa guiones bajos para separar palabras. Ejemplo:
                    </p>
                    <p>
                      Estimado <strong>&#123;&#123;nombre_usuario&#125;&#125;</strong>, tu factura del mes de
                      <strong>&#123;&#123;nombre_mes&#125;&#125;</strong> por
                      S/<strong>&#123;&#123;deuda_cliente&#125;&#125;</strong> está pendiente.
                    </p>
                  </template>
                  <InfoCircleOutlined style="margin-left: 5px" />
                </a-tooltip>
              </template>
              <div class="tts-textarea">
                <!-- v-if="isTtsTextFocused" -->
                <pre
                  class="tts-textarea__preview"
                  aria-hidden="true"
                ><template
                    v-for="(part, index) in ttsTextParts"
                    :key="index"
                  ><span
                      v-if="part.isVariable && !isTtsTextFocused"
                      class="tts-textarea__variable"
                      :class="{ 'tts-textarea__variable--repited': showTtsRepeatedVariables && part.isRepited }"
                    >{{ part.text }}</span><span v-else 
                      :class="{ 'tts-textarea__variable-edit': part.isVariable, 
                        'tts-textarea__variable-edit--repited': showTtsRepeatedVariables && part.isRepited
                      }">{{ part.text }}</span></template></pre>
                <!-- :class="{ 'tts-textarea__input--overlay': !isTtsTextFocused }" -->
                <a-textarea
                  ref="ttsTextInput"
                  v-model:value="formState.tts_text"
                  class="tts-textarea__input tts-textarea__input--overlay"                  
                  :maxlength="700"
                  :rows="5"
                  placeholder="Hola {{nombre_usuario}}, te recordamos que tu pago pendiente es {{saldo_pendiente}}. Evita generar intereses realizando tu pago hoy."
                  @focus="isTtsTextFocused = true"
                  @blur="isTtsTextFocused = false"
                />
              </div>
            </a-form-item>

            <div class="tts-toolbar">
              <div class="tts-toolbar__left">
                <a-button
                  size="small"
                  :disabled="ttsVariableLimitExceeded || formState.tts_variables.length >= 5"
                  @click="handleInsertTtsVariable"
                >
                  {{ "{}" }} Insertar variable
                </a-button>

                <a-tooltip
                  :title="
                    ttsVariableLimitExceeded
                      ? 'Superaste el límite máximo permitido de 5 variables.'
                      : null
                  "
                >
                  <span :class="{ 'tts-variable-error': ttsVariableLimitExceeded }">
                    <WarningOutlined v-if="ttsVariableLimitExceeded" />
                    {{ `${formState.tts_variables.length} de 5 variables` }}
                  </span>
                </a-tooltip>
              </div>

              <div class="tts-toolbar__right">
                {{ ttsBillableCharacters }} / 700 caracteres
                <a-tooltip>
                  <template #title>
                    Las variables no se incluyen en el conteo de caracteres ya que tienen un
                    valor de 200 caracteres por defecto.
                  </template>
                  <InfoCircleOutlined />
                </a-tooltip>
              </div>
            </div>

            <div class="tts-footer">
              <div class="tts-footer__center">
                <a-popover
                  trigger="hover"
                  placement="top"
                  overlay-class-name="tts-cost-popover"
                >
                  <template #content>
                    <div class="tts-cost">
                      <h4>Costo estimado por audio</h4>
                      <div class="tts-cost__row">
                        <span>Por caracter ({{ formatCurrency(ttsCharacterUnitCost) }} x {{ ttsBillableCharacters }})</span>
                        <strong>{{ formatCurrency(ttsCharacterCost) }}</strong>
                      </div>
                      <div class="tts-cost__row">
                        <span>Por variable ({{ formatCurrency(ttsVariableUnitCost) }} x {{ formState.tts_variables.length }})</span>
                        <strong>{{ formatCurrency(ttsVariableCost) }}</strong>
                      </div>
                      <div class="tts-cost__total">
                        <span>Total por audio</span>
                        <strong>{{ formatCurrency(ttsAudioCost) }}</strong>
                      </div>
                      <p>
                        Este costo será multiplicado por el número de registros en tu plantilla
                        para obtener el costo total de la estrategia.
                      </p>
                    </div>
                  </template>
                  <span class="tts-footer__cost">
                    <InfoCircleOutlined />
                    Costo estimado por audio: {{ formatCurrency(ttsAudioCost) }}
                  </span>
                </a-popover>
              </div>

              <div class="tts-footer__right">
                <span>{{ ttsAttempts }} de {{ ttsAttemptLimit }} intentos</span>

                <a-popover
                  placement="right"
                  :open="isTtsExtraAttemptCoolingDown && ttsExtraAttemptPopoverOpen"
                  overlay-class-name="tts-extra-attempt-popover"
                >
                  <template #content>
                    <div class="tts-extra-attempt-popover__content">
                      <h4>Alcanzaste el límite de 3 intentos</h4>
                      <p>
                        Si requieres un cambio adicional, podrás realizar un intento extra en
                        {{ formattedTtsExtraAttemptCountdown }}.
                      </p>
                      <a-button size="small" @click="ttsExtraAttemptPopoverOpen = false">
                        Entendido
                      </a-button>
                    </div>
                  </template>
                  <a-button
                    type="primary"
                    :disabled="!canOpenTtsPreview"
                    @click="openTtsPreviewModal"
                  >
                    {{ ttsGenerateButtonText }}
                  </a-button>
                </a-popover>
              </div>
            </div>

            <div v-if="ttsAudioUrl" class="audio-generated">
              <h4>
                Audio generado
                <a-tag v-if="showTtsNewVersionTag" color="orange" style="font-weight: 400">
                  Nueva versión disponible
                </a-tag>
              </h4>
              <p class="message--info">
                Escucha tu texto convertido a audio. Recuerda que si generas uno nuevo este será reemplazado.
              </p>

              <CallAudioPlayer
                :audio-url="ttsAudioUrl"
                volumen="vertical"
                :playerStyle="{
                  padding: '2px 10px',
                  'margin-top': '10px'
                }"
                hide-velocity
              />
              <!-- <audio controls :src="ttsAudioUrl" style="width: 100%" /> -->
            </div>
          </div>

          <div
            v-if="
              [TypeStrategy.IvrReturn, TypeStrategy.Ivr].includes(typeStrategy) &&
              formState.audio_config_type === AudioConfigType.Tts &&
              ttsAudioUrl
            "
            class="card"
          >
            <h4>
              Plantilla de contactos
              <a-tag v-if="showTtsNewVersionTag" color="orange" style="font-weight: 400">
                Nueva versión disponible
              </a-tag>
            </h4>
            <p class="message--info">
              Esta plantilla se actualiza según las variables configuradas en el Text To Speech.
              Descarga y completa la última versión antes de cargarla en la estrategia.
            </p>

            <a-button
              block
              type="primary"
              style="margin-top: 10px"
              ghost
              :loading="downloadingTtsTemplate"
              @click="handleDownloadTtsTemplate"
            >
              <DownloadOutlined />
              Descargar plantilla
            </a-button>
          </div>

          <!-- Opciones segun tipo de estrategia -->
          <div v-if="showFilePicker" class="card">
            <header class="download-header">
              <h4 style="margin: 0">Carga tu archivo aquí</h4>
              <a-tooltip
                title="Conoce los criterios que tu archivo debe cumplir para cargar tus contacto con éxito."
              >
                <a-button class="card__action" type="link" @click="openUploadCriteria">
                  <img class="card__icon" :src="fileCheck" alt="Criterios de carga" />
                  Ver criterios de carga
                </a-button>
              </a-tooltip>  
            </header>
            <div class="card card--light info">
              <InfoCircleOutlined class="container-file" />
              <span
                v-if="formState.audio_config_type === AudioConfigType.Tts"
                class="info--text"
              >
                Adjunta la última versión de tu plantilla de contactos con las variables
                configuradas. Recuerda que solo se permiten hasta 200 caracteres por variable.
              </span>
              <span v-else class="info--text" action="Cerrar">
                Recuerda que tenemos una plantilla predefinida para este tipo de estrategia. Si aún no la tienes, haz clic en
                <a :href="templateLink">Descargar plantilla</a>.
                <template v-if="plan === PlanSpecial">
                  Asegúrate de revisar los criterios de carga antes de subir tu archivo.
                </template>
                <template v-else>
                  El archivo permite <strong font-weight="600">máximo {{maxContactsStrategy}} filas</strong>. Conoce más en los criterios de carga.
                </template>
              </span>
            </div>
            <div class="container__archive">
              <archive-picker
                v-model:value="file"
                :empty-text="plan === PlanSpecial ? 'Arrastra tu archivo aquí' : `Máximo ${maxContactsStrategy} filas`"
                @update:value="handleChangeInput"
              ></archive-picker>
            </div>
            <a-alert
              v-if="ttsValidationReportResponse"
              class="tts-validation-report"
              type="warning"
              show-icon
            >
              <template #message>
                Tu archivo cuenta con errores en una o más celdas.
                <a-button type="link" @click="handleDownloadTtsValidationReport">
                  Descargar reporte de errores
                </a-button>
              </template>
            </a-alert>
          </div>
          <div v-if="showFilePicker && formState.audio_config_type === AudioConfigType.Tts" class="card">
            <h4>Costo total de la estrategia:</h4>
            <a-alert
              type="info"
              show-icon
            >
              <template #message>
                El costo total de la estrategia se calcula multiplicando el costo por audio por
                el número de registros en tu plantilla. Ejemplo: $0.001 (Costo por audio) x 100
                registros = $0.1
              </template>
            </a-alert>
          </div>

          <!--Opcion SMS -->
          <template v-if="typeStrategy === strategyType.createTemplateBySms">
            <div v-if="openSms" class="card">
              <h4>
                {{
                  formState.message_type === "template"
                    ? "Selecciona tu plantilla de SMS"
                    : "Redacta el mensaje de tu SMS"
                }}
              </h4>

              <div style="display: flex; gap: 36px; align-items: flex-start">
                <SmsTemplatePicker
                  :type="formState.message_type"
                  select-label="Selecciona la plantilla de SMS que utilizarás en esta estrategia"
                  :queue="formState.queue"
                  allParameters
                  @update:message="formState.message = $event"
                  @update:templateId="formState.template = $event"
                  @update:template="smsTemplate = $event"
                  @update:templateItem="currentTemplateSms = $event"
                  @valid="handleChangeInput($event)"
                >
                  <template #preview-button>
                    <a-popover arrowPointAtCenter placement="right">
                      <template #content>
                        <SmsTemplatePhone v-if="formState.template" :content="smsTemplate" />
                        <span v-else>
                          Selecciona una plantilla para
                          <br />
                          poder previsualizar su contenido.
                        </span>
                      </template>

                      <a-button :disabled="!formState.template" type="link">
                        Previsualiza tu plantilla
                      </a-button>
                    </a-popover>
                  </template>
                </SmsTemplatePicker>

                <SmsTemplatePhone
                  style="margin-bottom: 16px"
                  v-if="formState.message_type === 'write'"
                  :content="formState.message"
                  preview="Visualiza el contenido de tu mensaje SMS aquí."
                />
              </div>
            </div>

            <div class="container__empty" v-if="!formState.message_type">
              <span v-if="formState.message_type === 'write'" class="message--info">
                Completa los campos para continuar con la importación de los teléfonos de la
                plantilla de SMS.
              </span>
              <span v-if="formState.message_type === 'template'" class="message--info">
                Selecciona tu plantilla para continuar con tu importación de los teléfonos y
                variables (si los tuviera) de la plantilla de SMS.
              </span>
            </div>

            <div class="card" v-else>
              <h4 v-if="formState.message_type === 'template' && currentTemplateSms">
                {{
                  currentTemplateSms?.parameters?.length > 0
                    ? `Plantilla con parámetros: `
                    : `Plantilla sin parámetros`
                }}
                <span class="template_detail">
                  {{ customLabel(currentTemplateSms) }}
                </span>
              </h4>
              <div v-if="currentTemplateSms?.parameters?.length > 0" style="margin-bottom: 20px">
                <a-form-item
                  style="margin-bottom: 16px"
                  label="Tipo de carga"
                >
                  <a-select
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    v-model:value="formState.type_upload"
                  >
                    <a-select-option v-for="option in chargesType" :key="option.value">
                      {{ option.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
                <template-parameters
                  v-if="formState.type_upload == TypeCharge.PersonalizedParameters"
                  v-model:values="formState.parameters_values"
                  hideTitle
                  :form="formRef"
                  :template="currentTemplateSms"
                  :portfolioId="formState.portfolio"
                  :description="`Personalice los parámetros ingresando un valor manualmente o seleccionando un atributo del contacto. Esto te permite ajustar fácilmente la configuración según tus necesidades específicas.`"
                  inStrategy
                />
              </div>
              <header class="download-header">
                <h4 style="margin: 0">Carga tus teléfonos y variables</h4>
                <a-tooltip
                  title="Conoce los criterios que tu archivo debe cumplir para cargar tus contacto con éxito."
                >
                  <a-button class="card__action" type="link" @click="openUploadCriteria">
                    <img class="card__icon" :src="fileCheck" alt="Criterios de carga" />
                    Ver criterios de carga
                  </a-button>
                </a-tooltip>  
              </header>
              <div class="card card--light info">
                <InfoCircleOutlined class="container-file" />
                <span class="info--text" action="Cerrar">
                  Revisa los criterios de carga antes de subir tu archivo. 
                  Además, recuerda que el total de mensajes enviados dependerá del tipo de caracteres que importes en tus variables.
                </span>
              </div>
              <div class="container__archive-divider">
                <a-button
                  type="primary"
                  ghost
                  size="small"
                  @click="handleDownloadSmsTemplate(formState.template)"
                >
                  Descargar plantilla

                  <DownloadOutlined />
                </a-button>
                <archive-picker
                  v-model:value="file"
                  @update:value="handleChangeInput"
                  :empty-text="plan === PlanSpecial ? 'Arrastra tu archivo aquí' : `Máximo ${maxContactsStrategy} filas`"
                ></archive-picker>
              </div>
            </div>
          </template>

          <!--Opcion Whatsapp -->
          <template v-if="openWhatsapp">
            <div class="card">
              <h4>Selecciona tu plantilla de WhatsApp</h4>
              <a-row :gutter="16">
                <a-col :span="18">
                  <a-form-item
                    label="Selecciona una de tus plantillas de WhatsApp que utilizarás en esta estrategia"
                    name="template"
                  >
                    <a-select
                      :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                      v-model:value="formState.template"
                      placeholder="Seleccionar plantilla"
                      @change="
                        handleChangeInput();
                        handleChangeTemplate();
                      "
                      :option-label-prop="'customLabel'"
                    >
                      <a-select-opt-group
                        label="Plantillas con parámetros"
                        v-if="templatesWhatsappWithParameters.length > 0"
                      >
                        <a-select-option
                          v-for="template in templatesWhatsappWithParameters"
                          :key="template.id.toString()"
                          :customLabel="`${customLabel(template)} (con parámetros)`"
                        >
                          {{ template.name }}
                          <span class="select-info">
                            {{
                              template.template_type
                                ? `(Tipo: ${getTemplateTypeText(template.template_type)})`
                                : ""
                            }}
                          </span>
                        </a-select-option>
                      </a-select-opt-group>
                      <a-select-opt-group
                        label="Plantillas sin parámetros"
                        v-if="templatesWhatsappWithoutParameters.length > 0"
                      >
                        <a-select-option
                          v-for="template in templatesWhatsappWithoutParameters"
                          :key="template.id.toString()"
                          :customLabel="`${customLabel(template)} (sin parámetros)`"
                        >
                          {{ template.name }}
                          <span class="select-info">
                            {{
                              template.template_type
                                ? `(Tipo: ${getTemplateTypeText(template.template_type)})`
                                : ""
                            }}
                          </span>
                        </a-select-option>
                      </a-select-opt-group>

                      <!-- <a-select-option v-for="item in templates" :key="item.id">
                        {{ item.name }}
                        <span class="select-info">
                          {{
                            item.template_type
                              ? `(Tipo: ${getTemplateTypeText(item.template_type)})`
                              : ""
                          }}
                        </span>
                      </a-select-option> -->
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-popover arrowPointAtCenter placement="right" @visibleChange="incrementScroll">
                    <template #content>
                      <!-- Se actualizó los estilos para no necesitar enviar como type=popover -->
                      <WhatsappTemplatePhone
                        :content="visualTemplate"
                        :file="templateFile"
                        :templateType="templateType"
                        :buttons="buttons"
                        :triggerScroll="triggerScroll"
                      />
                    </template>

                    <a-button type="link" class="view-template">
                      Previsualiza tu plantilla
                    </a-button>
                  </a-popover>
                </a-col>
              </a-row>
            </div>

            <div class="card" v-if="formState.template">
              <h4 v-if="templateType !== WhatsappTemplateTypes.Text && currentTemplate">
                {{
                  currentTemplate?.parameters?.length > 0
                    ? `Plantilla con parámetros: `
                    : `Plantilla sin parámetros`
                }}
                <span class="template_detail">
                  {{ customLabel(currentTemplate) }}
                </span>
              </h4>
              <div v-if="currentTemplate?.parameters?.length > 0" style="margin-bottom: 20px">
                <a-form-item
                  style="margin-bottom: 16px"
                  label="Tipo de carga"
                >
                  <a-select
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    v-model:value="formState.type_upload"
                  >
                    <a-select-option v-for="option in chargesType" :key="option.value">
                      {{ option.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
                <template-parameters
                  v-if="formState.type_upload == TypeCharge.PersonalizedParameters"
                  v-model:values="formState.parameters_values"
                  hideTitle
                  :form="formRef"
                  :template="currentTemplate"
                  :portfolioId="formState.portfolio"
                  :description="`Personalice los parámetros ingresando un valor manualmente o seleccionando un atributo del contacto. Esto te permite ajustar fácilmente la configuración según tus necesidades específicas.`"
                  inStrategy
                />
              </div>
              <div v-if="templateType !== WhatsappTemplateTypes.Text">
                <h4>
                  Carga tu {{ getTemplateTypeText(templateType)?.split(" ")?.at(-1) || "archivo" }}
                </h4>
                <div class="card card--light info">
                  <InfoCircleOutlined class="container-file" />
                  <span class="info--text">
                    Recuerda que solo podrás adjuntar un único archivo. Este será enviado junto al
                    texto de la plantilla.
                  </span>
                </div>
                <div class="container__archive">
                  <archive-picker
                    v-model:value="templateFile"
                    @update:value="handleChangeInput"
                    :supported-types="supportedTypes"
                    :maxMBSize="maxMBSize"
                  />
                </div>
              </div>
              <div v-if="formState.template">
                <a-spin :spinning="loadingTemplateLimit">
                  <header class="download-header">
                    <span style="margin: 0;">Descarga primero tu plantilla WhatsApp y luego súbela</span>
                    <a-tooltip
                      title="Conoce los criterios que tu archivo debe cumplir para cargar tus contacto con éxito."
                    >
                      <a-button class="card__action" type="link" @click="openUploadCriteria">
                        <img class="card__icon" :src="fileCheck" alt="Criterios de carga" />
                        Ver criterios de carga
                      </a-button>
                    </a-tooltip>  
                  </header>
                  <div
                    v-if="!loadingTemplateLimit"
                    class="card card--light info"
                    :class="{ warning: !remainingTemplateMessages }"
                  >
                    <InfoCircleOutlined class="container-file" />
                    <span class="info--text" action="Cerrar">
                      <template v-if="remainingTemplateMessages">
                        Revisa los criterios de carga antes de subir tu archivo. Además, recuerda que puedes enviar 
                        <strong font-weight="600">máximo {{ remainingTemplateMessages }} plantillas</strong> desde tu
                        identificador {{ currentTemplate?.channel_customer?.associate }} según tu
                        <a
                          href="https://developers.facebook.com/docs/whatsapp/messaging-limits/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          TIER.
                        </a>
                      </template>

                      <template v-else>
                        Llegaste a tu límite de envío de mensajes de plantillas disponible según tu
                        en
                        <a
                          href="https://developers.facebook.com/docs/whatsapp/messaging-limits/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          TIER.
                        </a>
                        tu identificador {{ currentTemplate?.channel_customer?.associate }}.
                      </template>
                    </span>
                  </div>
                  <div class="container__archive-divider">
                    <a-button type="primary" ghost size="small" @click="handleDownloadTemplate">
                      <DownloadOutlined /> <br/>
                      Descargar tu plantilla aquí
                    </a-button>
                    <archive-picker
                      v-model:value="file"
                      @update:value="handleChangeInput"
                      :empty-text="plan === PlanSpecial ? 'Arrastra tu archivo aquí' : `Máximo ${maxContactsStrategy} filas`"
                    ></archive-picker>
                  </div>
                </a-spin>
              </div>
            </div>
          </template>

          <!--Opcion Predictivo -->
          <no-contact-picker
            ref="noContactPickerRef"
            v-if="typeStrategy == TypeStrategy.Predictive"
            :idPortfolio="portfolio"
            :portfolioName="portfolioName"
          />


          <div class="card" v-if="typeStrategy == TypeStrategy.IvrReturn">
            <h4>Ingresa el número de transferencia de llamada</h4>
            <span style="margin-bottom: 10px">
              Se debe ingresar el mismo número que tu audio menciona para transferir la llamada hacia la cola. Si ingresas un número diferente o tu audio no menciona ninguno, la llamada no se transferirá.
            </span>
            <div class="number-transfer">
              <span>
                <span class="required">*</span>
                Número de transferencia:
                <a-tooltip>
                  <template #title>
                    Solo se puede ingresar un número del 0 al 9.
                  </template>
                  <InfoCircleOutlined style="margin-left: 5px" />
                </a-tooltip>
              </span>
              <a-form-item
                label=""
                name="transfer_number"
              >
                <a-input-number
                  v-model:value="formState.transfer_number" 
                  min="0"
                  max="9"
                />
              </a-form-item>
            </div>
          </div>
          <marking-speed-picker
            v-if="typeStrategy == TypeStrategy.Predictive"
            v-model:value="formState.intensity_level"
          />

          <!-- Cierre automático de tickets sin respuesta ni atención -->
          <div class="card" v-if="typeStrategy === TypeStrategy.Whatsapp">
            <div class="auto-close__header">
              <span id="auto-close-label" class="title__strong">
                Cerrar automáticamente tickets sin respuesta ni atención
              </span>
              <a-switch
                v-model:checked="formState.enable_auto_close"
                size="small"
                aria-labelledby="auto-close-label"
                @change="handleAutoCloseChange"
              />
            </div>

            <p class="message--info auto-close__description">
              Activa esta opción para resolver automáticamente los tickets que no reciban respuesta
              del contacto ni atención de un agente dentro del tiempo de espera configurado.
              <strong>El conteo inicia desde la creación de cada ticket.</strong>
            </p>

            <div class="auto-close__item">
              <a-form-item name="auto_close_time">
                <div class="auto-close__time">
                  <span>
                    Tiempo de espera
                    <a-tooltip
                      title="Tiempo máximo para que el contacto responda o un agente atienda el ticket antes de que se cierre automáticamente."
                    >
                      <InfoCircleOutlined style="color: #00000073"/>
                    </a-tooltip>
                    :
                  </span>
                  <a-select
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    v-model:value="formState.auto_close_time"
                    :options="autoCloseTimeOptions"
                    :disabled="!formState.enable_auto_close"
                    placeholder="Seleccionar"
                    class="auto-close__select"
                  />
                </div>
              </a-form-item>
            </div>
          </div>
        </section>
      </custom-scrollbar>

      <div class="container__footer">
        <a-row type="flex" justify="end">
          <a-col>
            <a-space>
              <a-button @click="handleCancel">Cancelar</a-button>
              <a-tooltip
                :title="
                  canGenerateWppStrategie
                    ? (
                      saveDisabled ? 
                      'Se deben completar todos los campos solicitados para generar la estrategia.' : null
                    )
                    : 'Por hoy, ya no se podrá generar estrategias con el identificador +51998918291 debido a que ya no cuentas con mensajes con plantillas disponibles según tu TIER. '
                "
              >
                <a-button
                  type="primary"
                  :loading="loading"
                  @click="handleGenerate"
                  id="create-strategy-button"
                  :disabled="saveDisabled || !canGenerateWppStrategie || (disabledForm && typeStrategy == TypeStrategy.IvrReturn )"
                >
                  Generar estrategia
                </a-button>
              </a-tooltip>
            </a-space>
          </a-col>
        </a-row>
      </div>
    </section>
  </a-form>
  <EmailSuspension v-model:open="openEmailModalSuspension" :customChannelId="customChannelId" />


  <a-modal
    :open="ttsPreviewOpen"
    title="Generar audio"
    centered
    ok-text="Generar audio"
    cancel-text="Cancelar"
    :confirm-loading="ttsPreviewLoading"
    :ok-button-props="{ disabled: !canGenerateTtsPreview || ttsPreviewLoading }"
    @ok="handleGenerateTtsAudio"
    @cancel="handleCancelTtsPreview"
  >
    <p class="message--info">
      Ingresa un valor de ejemplo para cada variable y escucha cómo sonará el audio con los datos de tu plantilla.
    </p>

    <a-row :gutter="16">
      <a-col
        v-for="variable in formState.tts_variables"
        :key="variable"
        :span="12"
      >
        <a-form-item :label="`{{${variable}}}`" required>
          <a-input
            v-model:value="ttsPreviewValues[variable]"
            placeholder="Escribir aquí"
          />
        </a-form-item>
      </a-col>
    </a-row>

    <a-alert
      type="warning"
      show-icon
      message="Recuerda que cada generación de audio contará como un intento."
    />
  </a-modal>

  <StrategyProgressModal
    :open="validatingTtsRecords"
    title="Validando registros..."
    description="Estamos verificando los registros de tu plantilla. Esto puede tomar unos segundos."
    :percent="ttsValidationProgress"
    image-alt="Validando registros"
  />

  <StrategyProgressModal
    :open="generatingStrategy"
    title="Generando estrategia..."
    description="Estamos preparando tu estrategia."
    :percent="strategyGenerationProgress"
    image-alt="Generando estrategia"
  />


  <RestrictionChangePlanModal
    :title="restrictionSource === 'tts' ?
      'Realiza un upgrade y accede a todo el poder de Beex.' :
      actionRestriction == ActionPlanStrategy.Upgrade ? 
      'Realiza un upgrade y accede a todo el poder de Beex.' : 
      'Obtén esta funcionalidad personalizando tu plan.'
    "
    v-model:open="openRestriction"
    :planRequest="planRequest"
    :showAlert="showAlertRestriction"
  >
    <template #description v-if="restrictionSource === 'tts'">
      Tu plan {{ PlanTypeText[plan] }} no incluye esta funcionalidad.
      Solicita un upgrade y potencia tu ambiente de trabajo.
      ¡Que tu viaje no se detenga!
    </template>
    <template #description v-else-if="!showAlertRestriction">
      Tu plan {{ PlanTypeText[plan] }} no incluye esta funcionalidad. <br/>
      Solicita un upgrade y potencia tu ambiente de trabajo. 
      ¡Que tu viaje no se detenga!
    </template>
    <template #body v-else>
      <p>
        Tu plan {{ PlanTypeText[plan] }} no incluye esta funcionalidad. <br/>
        Solicita personalizar tu plan para potenciar tu ambiente de trabajo.
      </p>
      <p>
        {{
          isClientBeexcc 
          ? "Cuenta con nosotros para elevar tu experiencia. Estamos listos para asistirte. ✨"
          : "Aprovecha al máximo todo lo que puedes lograr con BeexCC. ¡Lleva tu experiencia más lejos! ✨"
        }}
      </p>
    </template>
  </RestrictionChangePlanModal>
</template>

<script>
import { fetchAllEntities, fetchPortfolios, fetchAllBases } from "@/app/entities/services";

import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import ArchivePicker from "@/app/shared/components/molecules/ArchivePicker.vue";
import WhatsappTemplatePhone from "@/app/shared/components/organisms/WhatsappTemplatePhone.vue";
import { templateLink } from "@/app/shared/utils/url";
import {
  defineComponent,
  ref,
  reactive,
  toRaw,
  computed,
  watch,
  h,
  watchEffect,
  provide,
  onMounted,
  onBeforeUnmount,
} from "vue";
import {
  InfoCircleOutlined,
  LeftOutlined,
  ExclamationCircleOutlined,
  WarningOutlined,
  DownloadOutlined,
  CloseCircleFilled,
} from "@ant-design/icons-vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Modal, message } from "ant-design-vue";
import { fetchQueues, fetchTemplates, fetchEmailTemplates } from "@/app/workspace/services";
import { ChannelType, StrategyType, TypeAssignment, StrategyDocs } from "@/app/shared/utils/enums";
import NoContactPicker from "@/app/strategies/components/pickers/NoContactPicker.vue";

import { AudioConfigType, TtsModel, TtsProvider, TtsVoiceType, TypeStrategy } from "@/@types/strategies/modalStrategy";

import {
  downloadTemplateWhatsapp,
  downloadTemplateEmail,
  fetchTemplateTierLimit,
  generateTtsPreview,
  downloadTtsTemplate,
  validateTtsExcel,
  fetchTtsPricing,
} from "@/app/strategies/services";
import { downloadFile } from "@/app/shared/utils/file";
import { WhatsappTemplateTypes } from "@/app/channels/utils/enums";
import { LaunchErrorType, TypeCharge } from "@/app/strategies/utils/enums";
import { ProductName } from "@/app/shared/utils/constants";

import QueuePicker from "@/app/shared/components/pickers/QueuePicker.vue";
import { humanDateFormat } from "@/app/shared/utils/constants";
import EditorComponent from "@/app/emails/components/editor/Editor.vue";
import EmailSuspension from "@/app/strategies/components/modals/EmailSuspension.vue";
import { fetchAllChannelsCustomersByPortfolio, fetchSendAsAliases } from "@/app/channels/services";
import SmsTemplatePicker from "../components/pickers/SmsTemplatePicker.vue";
import SmsTemplatePhone from "@/app/channels/components/modals/sms/templates/SmsTemplatePhone.vue";
import { smsTemplatesService } from "@/app/channels/services/SmsTemplates.service";
import InputActionButtons from "@/app/shared/components/buttons/InputActionButtons.vue";
import dayjs from "dayjs";
import TemplateParameters from "@/app/flows/sequences/components/sections/drawerForms/TemplateParameters.vue";
import { TemplateType } from "@/@types/flows/emailTemplates";
import AudioIvrPicker from "@/app/strategies/components/pickers/AudioIvrPicker.vue";
import { PlanType, PlanTypeStrategy, PlanTypeText } from "@/app/common/types";
import RestrictionChangePlanModal from "@/app/common/components/modals/RestrictionChangePlanModal.vue";
import { planConfigServices } from "@/app/common/services/PlanConfigServices";
import { ActionPlanStrategy, ActionPlanStrategyText, ActionPlanStrategyColor } from "@/app/common/utils/enums";
import TypeAssignmentPicker from "../components/pickers/TypeAssignmentPicker.vue";
import { disabledDate, disabledTime } from "@/app/shared/utils/dates";

import MarkingSpeedPicker from "../components/pickers/MarkingSpeedPicker.vue";
import CallAudioPlayer from "@/app/supervision/components/audio/CallAudioPlayer.vue";
import StrategyProgressModal from "@/app/strategies/components/modals/StrategyProgressModal.vue";
import fileCheck from "@/app/strategies/assets/file_check.svg?url";
import EventBus from "@/app/shared/utils/eventBus";
import { OPEN_HELP_CENTER_EVENT } from "@/app/entities/utils/helpCenter";
const PlanSpecial = 5;
const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/operaciones/estrategias`;
const DEFAULT_TTS_CHARACTER_COST = 0.000004;
const DEFAULT_TTS_VARIABLE_COST = 0.0008;
const TTS_EXTRA_ATTEMPT_DELAY_SECONDS = 180;

export default defineComponent({
  components: {
    CustomScrollbar,
    ArchivePicker,
    WhatsappTemplatePhone,
    InfoCircleOutlined,
    CloseCircleFilled,
    ExclamationCircleOutlined,
    WarningOutlined,
    LeftOutlined,
    QueuePicker,
    DownloadOutlined,
    EditorComponent,
    EmailSuspension,
    SmsTemplatePicker,
    SmsTemplatePhone,
    InputActionButtons,
    NoContactPicker,
    TemplateParameters,
    AudioIvrPicker,
    MarkingSpeedPicker,
    RestrictionChangePlanModal,
    TypeAssignmentPicker,
    CallAudioPlayer,
    StrategyProgressModal,
  },
  async setup() {
    const router = useRouter();

    const formRef = ref();
    const store = useStore();
    const entity = ref(0);
    // Valor solo para mover el scroll hacia arriba
    const triggerScroll = ref(0);

    const isTypeBusiness = computed(() => user.value?.customer?.type_business == 2);
    const user = computed(() => store.getters["getDataUser"]);

    const plan = computed(() => user.value?.change_custom_plan?.plan);
    const planConfigTenant = computed(() => user.value?.change_custom_plan?.custom_plan_config);
    const isClientBeexcc = computed(() => user.value?.is_beexcc);
    const dataPlan = computed(() => store.getters["getDataPlanDetails"]);
    const havePredictivePlan = computed(() => {
      return dataPlan.value?.configuration?.dial_predictive?.active && 
        dataPlan.value?.configuration?.dial_predictive?.checked;
    });
    const haveIvrPlan = computed(() => {
      return dataPlan.value?.configuration?.ivr_outbound?.active && 
        dataPlan.value?.configuration?.ivr_outbound?.checked;
    });
    const maxContactsStrategy = computed(() => {
      const maxContacts = dataPlan.value?.configuration?.max_contacts_strategy?.value;
      return maxContacts === undefined || maxContacts === null
        ? undefined
        : Number(maxContacts).toLocaleString("en-US");
    });

    const openRestriction = ref(false);
    const planRequest = ref();
    const showAlertRestriction = ref(false);
    const actionRestriction = ref();
    const restrictionSource = ref(null);

    const entites = computed(() => store.getters["getEntityList"]);
    const queues = ref([]);
    const templates = ref([]);
    const emailTemplates = ref([]);
    const email_time = ref(null);
    const email_date = ref(null);
    const customChannelId = ref(0);
    const noContactPickerRef = ref();
    const currentTemplateSms = ref();

    const formState = reactive({
      name: "",
      entity: undefined,
      portfolio: undefined,
      base: undefined,
      strategy_category: undefined,
      type_strategy: undefined,
      type_assignment: undefined,
      queue: undefined,
      destination: undefined,
      subject: null,
      message_preview: null,
      channel_customer: undefined,
      send_as_alias_identifier: null,
      email_type: undefined,
      execution_time: "",
      template_email: null,
      message: "",
      template: undefined,
      email_type_send: null,
      nc_regenerate: false,
      nc_rounds: 0,
      nc_results: [],
      nc_results_childrens: [],
      type_upload: TypeCharge.ChargeParameters,
      audio_ivr_return: null,
      intensity_level: 3,

      // text to speech
      audio_config_type: AudioConfigType.Upload,
      tts_provider: TtsProvider.Google,
      tts_model: TtsModel.Wavenet,
      tts_voice_type: TtsVoiceType.Female,
      tts_text: "",
      tts_variables: [],
      tts_generated_audio: null,

      // cierre automático de tickets
      enable_auto_close: false,
      auto_close_time: undefined,
    });

    const ttsProviders = [
      { value: TtsProvider.Google, label: "Google Cloud" },
    ];

    const ttsModels = [
      { value: TtsModel.Wavenet, label: "WaveNet" },
    ];

    const ttsVoiceTypes = [
      { value: TtsVoiceType.Female, label: "Femenina" },
      { value: TtsVoiceType.Male, label: "Masculina" },
    ];

    const autoCloseTimeOptions = [1, 3, 6, 12, 24, 48].map((hours) => ({
      value: hours,
      label: hours === 1 ? "1 hora" : `${hours} horas`,
    }));

    const handleAutoCloseChange = (checked) => {
      if (!checked) formState.auto_close_time = undefined;
      else if (!formState.auto_close_time) formState.auto_close_time = autoCloseTimeOptions[0].value;
    };
    
    const executionTimeRules = [
      { required: true, message: "Campo requerido" },
      {
        validator: (_, value) => {
          if (!value) return Promise.resolve();
          if (dayjs(value).startOf('minute').isBefore(dayjs().startOf('minute'))) {
            return Promise.reject("La fecha y hora no deben ser anteriores a la actual");
          }
          return Promise.resolve();
        },
        trigger: "change",
      },
    ];
    
    const chargesType = computed(() => {
      if (formState.type_strategy === StrategyType.email) {
        return [
          { value: TypeCharge.ChargeParameters, label: 'Carga tus correos y parámetros'},
          { value: TypeCharge.PersonalizedParameters, label: 'Personaliza los parámetros'},
        ];
      } else {
        return [
          { value: TypeCharge.ChargeParameters, label: 'Carga tus teléfonos y parámetros'},
          { value: TypeCharge.PersonalizedParameters, label: 'Personaliza los parámetros'},
        ];
      }
    });

    provide("formState", formState);

    const checkValidateNcRegenerate = async () => {
      if (formState.nc_regenerate && formState.nc_results_childrens.length == 0)
        return Promise.reject("Campo requerido");
      if (!formState.nc_regenerate || formState.nc_results_childrens.length > 0)
        return Promise.resolve();
    };

    const rules = {
      name: [{ required: true, message: "Campo requerido" }],
      entity: [{ required: true, message: "Campo requerido" }],
      portfolio: [{ required: true, message: "Campo requerido" }],
      base: [{ required: true, message: "Campo requerido" }],
      strategy_category: [{ required: true, message: "Campo requerido" }],
      type_strategy: [{ required: true, message: "Campo requerido" }],
      type_assignment: [{ required: true, message: "Campo requerido" }],
      queue: [{ required: true, message: "Campo requerido" }],
      subject: [{ required: true, message: "Campo requerido" }],
      channel_customer: [{ required: true, message: "Campo requerido" }],
      email_type_send: [{ required: true, message: "Campo requerido" }],
      destination: [{ required: true, message: "Campo requerido" }],
      type_upload: [{ required: true, message: "Campo requerido" }],
      tts_text: [{ required: true, message: "Campo requerido" }],
      template: [{ required: true, message: "Campo requerido" }],
      template_email: [{ required: true, message: "Campo requerido" }],
      nc_results_childrens: [{ validator: checkValidateNcRegenerate, trigger: "change" }],
      nc_rounds: [{ required: true, message: "Campo requerido" }],
      audio_ivr_return: [{ required: true, message: "" }],
      transfer_number: [
        { required: true, message: "Campo requerido" },
        { pattern: /^[0-9]$/, message: "El valor debe estar entre 0 y 9" },
      ],
    };

    if (user.value) {
      if (user.value.customer.type_business == 2) {
        entity.value = 1;
      }
    }

    const incrementScroll = () => triggerScroll.value++;

    watch(user, async (newValue) => {
      if (newValue.customer.type_business == 2) {
        entity.value = 1;
      }
    });

    onBeforeUnmount(() => {
      if (formState.tts_generated_audio) {
        URL.revokeObjectURL(formState.tts_generated_audio);
      }
    });

    const openWhatsapp = ref(false);
    const openEmail = ref(false);
    const openEmailModalSuspension = ref(false);
    const isEmailSuspended = ref(false);
    const selectedScheduleTime = ref(false);
    const remainingTemplateMessages = ref();
    const displayEmailTemplate = ref("");

    watch(
      () => formState.type_strategy,
      () => {
        if (formState.type_strategy != StrategyType.whatsapp || (formState.type_strategy == StrategyType.whatsapp && !formState.queue)) {
          openWhatsapp.value = false;
        }
        if (formState.type_strategy == StrategyType.whatsapp && formState.queue) {
          openWhatsapp.value = true;
        }
        openEmail.value = false;
        selectedScheduleTime.value = false;
        remainingTemplateMessages.value = undefined;
      }
    );

    const disabledForm = ref(true);

    watch(
      () => formState,
      async () => {
        if (formRef.value) {
          try {
            await formRef.value.validateFields();
            disabledForm.value = false;
          } catch {
            disabledForm.value = true;
          }
        }
      },
      { deep: true }
    );

    watchEffect(() => {
      console.log("Custom Channel ID changed:", customChannelId.value);
    });

    const handleCancel = () => {
      if (formState?.name || formState?.strategy_category) {
        Modal.confirm({
          title: "¿Deseas descartar tu progreso realizado?",
          icon: h(ExclamationCircleOutlined),
          content: "Al descartar, no se quedará guardado los datos previamente completados.",
          okText: "Sí, descartar",
          cancelText: "No, seguir completando",
          centered: true,
          onOk() {
            router.push("/strategies");
          },
        });
      } else
        router.push("/strategies");
    };

    const handleNavigateToTypifications = () => {
      Modal.confirm({
        title: "Serás dirigido a otro módulo y tu progreso no se guardará, ¿deseas continuar?",
        icon: h(ExclamationCircleOutlined),
        content: "Al salir de la configuración actual, tu progreso no se guardará. Si continúas, serás dirigido a la vista de “Tipificaciones”.",
        okText: "Sí, continuar",
        cancelText: "No, seguir configurando",
        centered: true,
        onOk() {
          router.push(`/operations/campaigns/${formState.portfolio}`);
        },
      });
    };

    const handleAddEmoji = (emoji) => {
      const lastClosingTagIndex = formState.message.lastIndexOf("</p>");

      const inputText = formState.message;

      formState.message =
        inputText.slice(0, lastClosingTagIndex) + emoji + inputText.slice(lastClosingTagIndex);
    };

    const templatesWhatsappWithParameters = computed(() => {
      return templates.value.filter((template) => template.parameters?.length > 0);
    });

    const templatesWhatsappWithoutParameters = computed(() => {
      return templates.value.filter((template) => template.parameters === null || template.parameters?.length == 0);
    });

    const emailTemplatesWithParameters = computed(() => {
      return emailTemplates.value.filter((template) => template.parameters?.length > 0);
    });

    const emailTemplatesWithoutParameters = computed(() => {
      return emailTemplates.value.filter((template) => template.parameters === null || template.parameters?.length == 0);
    });

    const currentStrategyHelp = computed(() => {
      const info = StrategyDocs[formState.type_strategy];
      if (!info) return null;
      return {
        url: `${DOCS_URL}/${info.slug}`,
        text: info.text
      }
    });

    return {
      StrategyType,
      TypeAssignment,
      rules,
      formState,
      formRef,
      isTypeBusiness,
      entites,
      user,
      queues,
      templates,
      emailTemplates,
      openWhatsapp,
      openEmail,
      handleCancel,
      handleNavigateToTypifications,
      handleAddEmoji,
      remainingTemplateMessages,
      openEmailModalSuspension,
      displayEmailTemplate,
      isEmailSuspended,
      email_date,
      email_time,
      customChannelId,
      ProductName,
      TypeStrategy,
      noContactPickerRef,
      templatesWhatsappWithParameters,
      templatesWhatsappWithoutParameters,
      chargesType,
      TypeCharge,
      currentTemplateSms,
      emailTemplatesWithParameters,
      emailTemplatesWithoutParameters,
      TemplateType,
      disabledForm,
      plan,
      havePredictivePlan,
      PlanType,
      openRestriction,
      PlanTypeText,
      planRequest,
      showAlertRestriction,
      haveIvrPlan,
      ActionPlanStrategy,
      ActionPlanStrategyText,
      ActionPlanStrategyColor,
      PlanSpecial,
      actionRestriction,
      restrictionSource,
      disabledDate,
      disabledTime,
      executionTimeRules,
      currentStrategyHelp,
      StrategyDocs,
      triggerScroll,
      incrementScroll,
      AudioConfigType,
      TtsProvider,
      TtsModel,
      TtsVoiceType,
      ttsProviders,
      ttsModels,
      ttsVoiceTypes,
      maxContactsStrategy,
      autoCloseTimeOptions,
      handleAutoCloseChange,
    };
  },
  data() {
    return {
      file: null,
      attachments: [],
      openSms: false,
      templateFile: null,
      entity: undefined,
      entities: [],
      portfolio: undefined,
      portfolioName: undefined,
      portfolios: [],
      emailIdentifiers: [],
      aliasesByIdentifier: {},
      selectedEmailOption: null,
      bases: [],
      typeStrategy: 0,
      emailTime: 0,
      emailType: 0,
      smsTemplate: "",
      loading: false,
      msjTemplate: "Aquí se visualizará tu plantilla de WhatsApp",
      strategyType: {
        createTemplateByPredictive: 1,
        createTemplateByProgressivee: 2,
        createTemplateBySms: 3,
        createTemplateByIVR: 4,
        createTemplateByWhatsApp: 5,
        createTemplateByEmail: 6,
      },
      templateLink,
      seletedStrategy: false,
      changeInput: false,
      WhatsappTemplateTypes,
      loadingTemplateLimit: false,
      humanDateFormat,
      predictiveTime: 0,

      // text to speech
      ttsPreviewOpen: false,
      ttsPreviewValues: {},
      ttsAudioUrl: null,
      ttsAttempts: 0,
      ttsExtraAttemptUnlocked: false,
      ttsExtraAttemptRemainingSeconds: 0,
      ttsExtraAttemptTimer: null,
      ttsExtraAttemptPopoverOpen: false,
      ttsPreviewLoading: false,
      downloadingTtsTemplate: false,
      ttsValidationProgress: 0,
      validatingTtsRecords: false,
      strategyGenerationProgress: 0,
      generatingStrategy: false,
      ttsValidationReportResponse: null,
      ttsLastGeneratedSignature: null,
      ttsLastGeneratedVariablesSignature: null,
      ttsNewVersionAvailable: false,
      isTtsTextFocused: false,
      showTtsRepeatedVariables: false,
      ttsRepitedVariablesSnapshot: [],
      ttsPricing: {
        character: DEFAULT_TTS_CHARACTER_COST,
        variable: DEFAULT_TTS_VARIABLE_COST,
      },
      ttsPricingLoading: false,
      ttsPricingRequestKey: null,
      fileCheck,
    };
  },
  computed: {
    // strategyTypes() {
    //   // Muestra SMS
    //   return this.$store.getters["getStrategyTypeList"];
    // },
    canGenerateTtsPreview() {
      return this.formState.tts_variables.every(
        variable => this.ttsPreviewValues[variable]
      );
    },
    ttsAttemptLimit() {
      return this.ttsAttempts >= 3 ? 4 : 3;
    },
    isTtsExtraAttemptCoolingDown() {
      return this.ttsAttempts >= 3 &&
        !this.ttsExtraAttemptUnlocked &&
        this.ttsExtraAttemptRemainingSeconds > 0;
    },
    formattedTtsExtraAttemptCountdown() {
      const minutes = Math.floor(this.ttsExtraAttemptRemainingSeconds / 60);
      const seconds = this.ttsExtraAttemptRemainingSeconds % 60;
      return `${minutes}:${String(seconds).padStart(2, "0")}`;
    },
    ttsGenerateButtonText() {
      if (this.isTtsExtraAttemptCoolingDown) {
        return `Generar audio en ${this.formattedTtsExtraAttemptCountdown}`;
      }

      return "Generar audio";
    },
    ttsVariableLimitExceeded() {
      return this.formState.tts_variables.length > 5;
    },
    ttsVariableNames() {
      return [
        ...(this.formState.tts_text || "").matchAll(/{{\s*([^{}]+?)\s*}}/g),
      ].map((match) => match[1].trim());
    },
    ttsRepitedVariables() {
      return [...new Set(
        this.ttsVariableNames.filter(
          (variable, index) => this.ttsVariableNames.indexOf(variable) !== index
        )
      )];
    },
    hasTtsRepitedVariables() {
      return this.ttsRepitedVariables.length > 0;
    },
    ttsTextParts() {
      const text = this.formState.tts_text || "";
      const regex = /{{\s*([^{}]+?)\s*}}/g;
      const parts = [];
      let lastIndex = 0;
      let match;

      while ((match = regex.exec(text)) !== null) {
        if (match.index > lastIndex) {
          parts.push({
            text: text.slice(lastIndex, match.index),
            isVariable: false,
          });
        }

        parts.push({
          text: match[0],
          isVariable: true,
          isRepited: this.ttsRepitedVariables.includes(match[1].trim()),
        });
        lastIndex = regex.lastIndex;
      }

      if (lastIndex < text.length) {
        parts.push({
          text: text.slice(lastIndex),
          isVariable: false,
        });
      }

      return parts.length ? parts : [{ text: "", isVariable: false }];
    },
    ttsBillableText() {
      return (this.formState.tts_text || "").replace(
        /(\s*){{\s*([^{}]+?)\s*}}/g,
        (_, spaces) => spaces ? " " : ""
      );
    },
    ttsBillableCharacters() {
      return this.ttsBillableText.length;
    },
    ttsCharacterUnitCost() {
      return this.ttsPricing.character;
    },
    ttsVariableUnitCost() {
      return this.ttsPricing.variable;
    },
    ttsCharacterCost() {
      return this.ttsBillableCharacters * this.ttsCharacterUnitCost;
    },
    ttsVariableCost() {
      return this.formState.tts_variables.length * this.ttsVariableUnitCost;
    },
    ttsAudioCost() {
      return this.ttsCharacterCost + this.ttsVariableCost;
    },
    currentTtsSignature() {
      return JSON.stringify({
        text: this.formState.tts_text,
        model: this.formState.tts_model,
        voice: this.formState.tts_voice_type,
      });
    },
    currentTtsVariablesSignature() {
      return JSON.stringify(this.formState.tts_variables);
    },
    showTtsNewVersionTag() {
      return Boolean(
        this.ttsAudioUrl &&
        this.ttsAttempts > 0 &&
        this.ttsNewVersionAvailable &&
        this.ttsAttempts < this.ttsAttemptLimit
      );
    },
    hasTtsTextChangedWithoutVariableChanges() {
      return Boolean(
        this.ttsLastGeneratedSignature &&
        this.currentTtsSignature !== this.ttsLastGeneratedSignature &&
        this.currentTtsVariablesSignature === this.ttsLastGeneratedVariablesSignature
      );
    },
    canRegenerateTtsBeforeStrategy() {
      return Boolean(
        this.ttsAttempts < 3 ||
        (this.ttsExtraAttemptUnlocked && this.ttsAttempts < this.ttsAttemptLimit)
      );
    },
    canOpenTtsPreview() {
      const canUseAttempt =
        this.ttsAttempts < 3 ||
        (this.ttsExtraAttemptUnlocked && this.ttsAttempts < this.ttsAttemptLimit);

      return Boolean(
        this.formState.tts_text?.trim() &&
        !this.ttsVariableLimitExceeded &&
        canUseAttempt &&
        !this.isTtsExtraAttemptCoolingDown &&
        this.currentTtsSignature !== this.ttsLastGeneratedSignature
      );
    },
    strategyTypes() {
      // Muestra SMS
      return this.$store.getters["getStrategyTypeList"]
        .filter((el) => el.id !== StrategyType.ivrReturn)
        .map((el) => {
          let item = el;
          if (
            (!this.accessPredictive && el?.id == TypeStrategy.Predictive) ||
            (!this.accessProgressive && el?.id == TypeStrategy.Progressive) ||
            (!this.accessSms && el?.id == TypeStrategy.Sms) ||
            (!this.accessIvr && el?.id == TypeStrategy.Ivr) ||
            (!this.accessWhatsapp && el?.id == TypeStrategy.Whatsapp) ||
            (!this.accessEmail && el?.id == TypeStrategy.Email)
          ) {
            item = { ...item, action: PlanTypeStrategy[this.plan]?.[el?.id] };
          }
          return item;
        });
    },
    ivrTypes() {
      return this.$store.getters["getStrategyTypeList"].filter((item) =>
        [StrategyType.ivr, StrategyType.ivrReturn].includes(item.id)
      ).map((item) => {
        console.log("item.id", item, item.id, StrategyType.ivr);
        return {
          ...item,
          name: item.id == StrategyType.ivr ? "IVR tradicional" : item.name,
        }
      });
    },
    isVoiceStrategy() {
      return [StrategyType.ivr, StrategyType.predictive, StrategyType.progressive].includes(
        this.typeStrategy
      );
    },
    templatesWhatsapp() {
      return this.$store.getters["getTemplatesWhatsapp"];
    },
    canGenerateWppStrategie() {
      if (this.remainingTemplateMessages === undefined) return true;

      return Boolean(this.remainingTemplateMessages);
    },
    showFilePicker() {
      const isTts = this.formState.audio_config_type === AudioConfigType.Tts;

      return (
        this.typeStrategy === this.strategyType.createTemplateByPredictive ||
        this.typeStrategy === this.strategyType.createTemplateByProgressivee ||
        (
          [
            this.strategyType.createTemplateByIVR,
            StrategyType.ivrReturn,
          ].includes(this.typeStrategy) &&
          (!isTts || Boolean(this.ttsAudioUrl))
        )
      );
    },
    currentQueue() {
      return this.queues.find((item) => item.id == this.formState.queue);
    },
    // text() {
    //   return this.templates.find((item) => item?.id == this.formState.template)?.template;
    // },
    visualTemplate() {
      return this.text || this.msjTemplate;
    },
    currentTemplate() {
      return this.templates.find((item) => item?.id == this.formState.template);
    },
    text() {
      return this.currentTemplate?.template;
    },
    templateType() {
      return this.currentTemplate?.template_type || WhatsappTemplateTypes.Text;
    },
    buttons() {
      return this.currentTemplate?.buttons ?? [];
    },
    supportedTypes() {
      let types = [];

      if (this.templateType === WhatsappTemplateTypes.TextAndImage)
        types = [".png", ".jpg", ".jpeg"];
      if (this.templateType === WhatsappTemplateTypes.TextAndVideo) types = [".mp4"];
      if (this.templateType === WhatsappTemplateTypes.TextAndDocument) types = [".pdf"];

      return types;
    },
    maxMBSize() {
      let size = null;

      if (this.templateType === WhatsappTemplateTypes.TextAndImage) size = 2;
      if (this.templateType === WhatsappTemplateTypes.TextAndVideo) size = 5;
      if (this.templateType === WhatsappTemplateTypes.TextAndDocument) size = 5;

      return size;
    },
    saveDisabled() {
      const isTts =
        [StrategyType.ivr, StrategyType.ivrReturn].includes(this.typeStrategy) &&
        this.formState.audio_config_type === AudioConfigType.Tts;
      const invalidTts =
        isTts &&
        (
          !this.ttsAudioUrl ||
          // !this.formState.destination ||
          this.ttsVariableLimitExceeded ||
          (
            this.currentTtsSignature !== this.ttsLastGeneratedSignature &&
            (
              !this.hasTtsTextChangedWithoutVariableChanges ||
              this.isTtsExtraAttemptCoolingDown ||
              !this.canRegenerateTtsBeforeStrategy
            )
          )
        );

      return (!this.changeInput && !this.file) || 
        this.formState.name == '' || !this.formState.entity || 
        !this.formState.portfolio || (this.typeStrategy == StrategyType.progressive && !this.formState.type_assignment) ||
        (
          !isTts &&
          (
            (this.typeStrategy == StrategyType.ivr && !this.formState.audio_ivr_return) ||
            (this.typeStrategy == StrategyType.ivrReturn && !this.formState.audio_ivr_return)
          )
        ) ||
        invalidTts;
    },
    accessPredictive() {
      return [PlanType.AllInOne, PlanSpecial].includes(this.plan) || 
        (
          [PlanType.Voice, PlanType.DigitalVoice].includes(this.plan) &&
          this.havePredictivePlan
        )
    },
    accessProgressive() {
      return this.plan != PlanType.Digital
    },
    accessSms() {
      return this.plan != PlanType.Voice
    },
    accessIvr() {
      return [PlanType.AllInOne, PlanSpecial].includes(this.plan) || 
        (
          [PlanType.Voice, PlanType.DigitalVoice].includes(this.plan)
          && this.haveIvrPlan
        )
    },
    accessWhatsapp() {
      return this.plan != PlanType.Voice
    },
    accessEmail() {
      return this.plan != PlanType.Voice
    },
    // accessTTS() {
    //   return [PlanType.AllInOne, PlanSpecial].includes(this.plan);
    // },
  },
  watch: {
    entites(newValue) {
      if (newValue?.length > 0) {
        if (this.isTypeBusiness) {
          this.formState.entity = this.entities.find((item) => item.is_owner).id;
          this.fetchPortfolios();
        }
      }
    },
    typeStrategy(value) {
      if (value == 2) return;
      this.formState.type_assignment = TypeAssignment.Random;
    },
    "formState.tts_text"() {
      const variables = [
        ...this.formState.tts_text.matchAll(/{{\s*([^{}]+?)\s*}}/g),
      ].map((match) => match[1].trim());
      const repitedVariables = [
        ...new Set(
          variables.filter(
            (variable, index) => variables.indexOf(variable) !== index
          )
        ),
      ];
      const hasSameRepitedVariables =
        repitedVariables.length === this.ttsRepitedVariablesSnapshot.length &&
        repitedVariables.every((variable) =>
          this.ttsRepitedVariablesSnapshot.includes(variable)
        );

      if (this.showTtsRepeatedVariables && !hasSameRepitedVariables) {
        this.showTtsRepeatedVariables = false;
        this.ttsRepitedVariablesSnapshot = [];
      }

      this.formState.tts_variables = [...new Set(variables)];
      this.invalidateTtsAudio();
    },
    "formState.tts_model"() {
      this.invalidateTtsAudio();
      this.loadTtsPricing();
    },
    "formState.tts_voice_type"() {
      this.invalidateTtsAudio();
      this.loadTtsPricing();
    },
    "formState.audio_config_type"(value) {
      if (value === AudioConfigType.Upload) {
        this.resetTtsConfiguration();
      }
    },
  },
  created() {
    this.fetchEntities();
    this.$store.dispatch("fetchAllEntities");
    this.fetchQueues();
    this.loadTtsPricing();
  },
  beforeUnmount() {
    this.clearTtsExtraAttemptCountdown();
  },
  methods: {
    async loadTtsPricing() {
      const model = this.formState.tts_model;
      const voice = this.formState.tts_voice_type;
      if (!model || !voice) return;

      const requestKey = `${model}:${voice}`;
      this.ttsPricingRequestKey = requestKey;
      this.ttsPricingLoading = true;

      try {
        const pricing = await fetchTtsPricing({ model, voice });
        if (this.ttsPricingRequestKey !== requestKey) return;

        const characterCost = Number(pricing?.sale_per_char ?? pricing?.sale_per_chat);
        const variableCost = Number(pricing?.sale_per_variable);

        this.ttsPricing = {
          character: Number.isFinite(characterCost) ? characterCost : DEFAULT_TTS_CHARACTER_COST,
          variable: Number.isFinite(variableCost) ? variableCost : DEFAULT_TTS_VARIABLE_COST,
        };
      } catch (error) {
        this.ttsPricing = {
          character: DEFAULT_TTS_CHARACTER_COST,
          variable: DEFAULT_TTS_VARIABLE_COST,
        };
      } finally {
        if (this.ttsPricingRequestKey === requestKey) {
          this.ttsPricingLoading = false;
        }
      }
    },
    clearTtsExtraAttemptCountdown() {
      if (this.ttsExtraAttemptTimer) {
        clearInterval(this.ttsExtraAttemptTimer);
        this.ttsExtraAttemptTimer = null;
      }
    },
    resetTtsAttemptLimit() {
      this.clearTtsExtraAttemptCountdown();
      this.ttsAttempts = 0;
      this.ttsExtraAttemptUnlocked = false;
      this.ttsExtraAttemptRemainingSeconds = 0;
      this.ttsExtraAttemptPopoverOpen = false;
    },
    startTtsExtraAttemptCountdown() {
      this.clearTtsExtraAttemptCountdown();
      this.ttsExtraAttemptUnlocked = false;
      this.ttsExtraAttemptPopoverOpen = true;
      this.ttsExtraAttemptRemainingSeconds = TTS_EXTRA_ATTEMPT_DELAY_SECONDS;

      this.ttsExtraAttemptTimer = setInterval(() => {
        this.ttsExtraAttemptRemainingSeconds -= 1;

        if (this.ttsExtraAttemptRemainingSeconds > 0) return;

        this.ttsExtraAttemptRemainingSeconds = 0;
        this.ttsExtraAttemptUnlocked = true;
        this.clearTtsExtraAttemptCountdown();
      }, 1000);
    },
    hasTtsConfigurationProgress() {
      return Boolean(
        this.formState.tts_text?.trim() ||
        this.formState.tts_variables.length ||
        this.ttsAudioUrl ||
        this.ttsAttempts ||
        this.ttsLastGeneratedSignature ||
        this.formState.destination ||
        this.file ||
        this.changeInput
      );
    },
    hasUploadAudioProgress() {
      return Boolean(this.formState.audio_ivr_return);
    },
    resetTtsConfiguration() {
      this.formState.destination = undefined;
      this.ttsValidationReportResponse = null;
      if (this.ttsAudioUrl) URL.revokeObjectURL(this.ttsAudioUrl);
      this.ttsAudioUrl = null;
      this.formState.tts_text = "";
      this.formState.tts_variables = [];
      this.formState.tts_generated_audio = null;
      this.formState.audio_ivr_return = null;
      this.ttsLastGeneratedSignature = null;
      this.ttsLastGeneratedVariablesSignature = null;
      this.ttsNewVersionAvailable = false;
      this.resetTtsAttemptLimit();
      this.ttsPreviewValues = {};
      this.showTtsRepeatedVariables = false;
      this.ttsRepitedVariablesSnapshot = [];
      this.file = null;
      this.changeInput = false;
    },
    resetUploadAudioConfiguration() {
      this.formState.audio_ivr_return = null;
    },
    applyAudioConfigType(value) {
      const currentValue = this.formState.audio_config_type;

      if (currentValue === AudioConfigType.Tts && value === AudioConfigType.Upload) {
        this.resetTtsConfiguration();
      }

      if (currentValue === AudioConfigType.Upload && value === AudioConfigType.Tts) {
        this.resetUploadAudioConfiguration();
      }

      this.formState.audio_config_type = value;
    },
    confirmAudioConfigTypeChange(value) {
      const isCurrentTts = this.formState.audio_config_type === AudioConfigType.Tts;

      Modal.confirm({
        title: "Estás a punto de cambiar la configuración de audio, ¿deseas continuar?",
        icon: h(ExclamationCircleOutlined),
        content: isCurrentTts
          ? "Al cambiar el método seleccionado, se descartará el texto y las variables ingresadas. Esta acción no se podrá deshacer."
          : "Al cambiar el método seleccionado, se descartará el audio cargado. Esta acción no se podrá deshacer.",
        okText: "Sí, cambiar",
        cancelText: "No, cancelar",
        centered: true,
        onOk: () => {
          this.applyAudioConfigType(value);
        },
      });
    },
    handleAudioConfigTypeChange(event) {
      const value = event?.target?.value;
      if (!value || value === this.formState.audio_config_type) return;

      const shouldConfirm =
        (
          this.formState.audio_config_type === AudioConfigType.Tts &&
          this.hasTtsConfigurationProgress()
        ) ||
        (
          this.formState.audio_config_type === AudioConfigType.Upload &&
          this.hasUploadAudioProgress()
        );

      if (shouldConfirm) {
        this.confirmAudioConfigTypeChange(value);
        return;
      }

      this.applyAudioConfigType(value);
    },
    handleInsertTtsVariable() {
      if (this.formState.tts_variables.length >= 5) return;

      let nextNumber = this.formState.tts_variables.length + 1;
      let variable = `variable${nextNumber}`;

      while (this.formState.tts_variables.includes(variable)) {
        nextNumber += 1;
        variable = `variable${nextNumber}`;
      }
      this.formState.tts_text = `${this.formState.tts_text || ""}{{${variable}}}`;
      this.$nextTick(() => {
        const textarea = this.$refs.ttsTextInput?.resizableTextArea?.textArea;

        if (!textarea) return;

        textarea.focus();
        textarea.setSelectionRange(textarea.value.length, textarea.value.length);
      });
    },

    openTtsPreviewModal() {
      if (this.hasTtsRepitedVariables) {
        this.ttsRepitedVariablesSnapshot = [...this.ttsRepitedVariables];
        this.showTtsRepeatedVariables = true;
        message.error("No fue posible generar el audio. Corrige las variables repetidas.");
        return;
      }

      this.ttsPreviewValues = {};

      this.formState.tts_variables.forEach((variable) => {
        this.ttsPreviewValues[variable] = "";
      });

      this.ttsPreviewOpen = true;
    },

    handleCancelTtsPreview() {
      const hasValues = Object.values(this.ttsPreviewValues).some((value) => value);

      if (!hasValues) {
        this.ttsPreviewOpen = false;
        return;
      }

      Modal.confirm({
        title: "¿Deseas descartar el progreso realizado?",
        content: "Al cancelar, se van a descartar todos los datos completados.",
        okText: "Sí, descartar",
        cancelText: "No, seguir completando",
        centered: true,
        onOk: () => {
          this.ttsPreviewOpen = false;
          this.ttsPreviewValues = {};
        },
      });
    },

    invalidateTtsAudio() {
      if (!this.ttsLastGeneratedSignature) return;
      if (this.currentTtsSignature === this.ttsLastGeneratedSignature) return;

      const variablesChanged =
        this.ttsLastGeneratedVariablesSignature &&
        this.currentTtsVariablesSignature !== this.ttsLastGeneratedVariablesSignature;

      if (this.ttsAttempts > 0 && variablesChanged) {
        this.ttsNewVersionAvailable = true;
        this.file = null;
        this.changeInput = false;
      }
    },

    async handleGenerateTtsAudio({ silent = false, closePreview = true } = {}) {
      const previewText = this.formState.tts_text.replace(
        /{{\s*([^{}]+?)\s*}}/g,
        (_, variable) => this.ttsPreviewValues[variable.trim()] ?? ""
      );

      try {
        this.ttsPreviewLoading = true;
        const audio = await generateTtsPreview({
          text: previewText,
          voice: this.formState.tts_voice_type,
          model: this.formState.tts_model,
        });

        if (!audio) throw new Error("La respuesta no contiene un audio");
        if (this.formState.audio_config_type !== AudioConfigType.Tts) return false;

        if (this.ttsAudioUrl) URL.revokeObjectURL(this.ttsAudioUrl);

        if (!(audio instanceof Blob)) {
          throw new Error("La respuesta no contiene un archivo de audio");
        }

        const audioExtension = audio.type?.includes("wav") ? "wav" : "mp3";
        const audioFile = new File([audio], `audio_tts.${audioExtension}`, {
          type: audio.type || `audio/${audioExtension}`,
        });

        this.ttsAudioUrl = URL.createObjectURL(audioFile);
        this.formState.tts_generated_audio = this.ttsAudioUrl;
        this.formState.audio_ivr_return = audioFile;
        this.ttsLastGeneratedSignature = this.currentTtsSignature;
        this.ttsLastGeneratedVariablesSignature = this.currentTtsVariablesSignature;
        this.ttsAttempts += 1;
        if (this.ttsAttempts === 3) this.startTtsExtraAttemptCountdown();
        this.ttsNewVersionAvailable = false;
        if (closePreview) this.ttsPreviewOpen = false;
        if (!silent) this.$message.success("Audio generado con éxito");
        return true;
      } catch (error) {
        if (!silent) {
          this.$message.error(error?.getErrorMessage?.() || "No se pudo generar el audio");
        }
        return false;
      } finally {
        this.ttsPreviewLoading = false;
      }
    },

    async handleDownloadTtsTemplate() {
      try {
        this.downloadingTtsTemplate = true;
        const template = await downloadTtsTemplate({
          // destination: this.formState.destination,
          // type_upload: this.formState.type_upload,
          variables: this.formState.tts_variables,
        });
        downloadFile(template, "plantilla_ivr_tts.zip");
      } catch (error) {
        this.$message.error(error?.getErrorMessage?.() || "No se pudo descargar la plantilla");
      } finally {
        this.downloadingTtsTemplate = false;
      }
    },

    async handleChangeTemplate() {
      this.loadingTemplateLimit = true;

      this.remainingTemplateMessages = await fetchTemplateTierLimit(
        this.currentTemplate.channel_customer.id
      );
      this.file = null;
      this.templateFile = null;

      this.loadingTemplateLimit = false;
    },
    currentEmailTemplate() {
      return this.emailTemplates.find((item) => item?.id == this.formState.template_email);
    },
    currentChannelCustomer() {
      return this.emailIdentifiers.find((item) => item?.id == this.formState.channel_customer);
    },
    formatCurrency(value) {
      const amount = Number(value) || 0;
      if (amount === 0) return "$0";

      return `$${amount.toFixed(6).replace(/0+$/, "").replace(/\.$/, "")}`;
    },
    buildTtsExcelValidationData() {
      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("name", toRaw(this.formState).name);
      formData.append("tts_text", this.formState.tts_text);
      formData.append("audio_cost", String(this.ttsAudioCost.toFixed(6)));
      this.formState.tts_variables.forEach((variable) => {
        formData.append("variables", variable);
      });

      return formData;
    },
    async validateTtsExcelBeforeGenerate() {
      try {
        const validationResult = await validateTtsExcel(
          this.buildTtsExcelValidationData(),
          (progressEvent) => {
            if (!progressEvent.total) return;
            const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            this.ttsValidationProgress = Math.min(percent, 90);
          }
        );

        if (validationResult?.isTtsExcelValidationFile) {
          this.ttsValidationReportResponse = validationResult.response;
          return false;
        }

        this.ttsValidationReportResponse = null;
        return true;
      } catch (error) {
        if (error?.isTtsExcelValidationFile) {
          this.ttsValidationReportResponse = error.response;
          return false;
        }

        throw error;
      }
    },
    handleDownloadTtsValidationReport() {
      if (!this.ttsValidationReportResponse) return;

      downloadFile(this.ttsValidationReportResponse, "validacion_tts_errors.txt", {
        useResponseFileName: true,
      });
    },
    handleGenerate() {
      this.formRef.validateFields().then(async () => {
        // const channel_customer = this.currentQueue?.channels_customer.find(
        //   (channel) => channel.channel.id == ChannelType.Whatsapp
        // ).id;
        const shouldRegenerateTtsAudioBeforeStrategy =
          [TypeStrategy.IvrReturn, TypeStrategy.Ivr].includes(this.typeStrategy) &&
          this.formState.audio_config_type === AudioConfigType.Tts &&
          this.hasTtsTextChangedWithoutVariableChanges;

        if (shouldRegenerateTtsAudioBeforeStrategy) {
          this.loading = true;
          const audioWasGenerated = await this.handleGenerateTtsAudio({
            silent: true,
            closePreview: false,
          });
          this.loading = false;

          if (!audioWasGenerated) {
            this.$message.error("No se pudo generar el audio");
            return;
          }
        }

        const formData = new FormData();
        formData.append("type_origin", 2);
        formData.append("name", toRaw(this.formState).name);
        formData.append("portfolio", toRaw(this.formState).portfolio);
        if (this.formState.queue) formData.append("queue", toRaw(this.formState).queue);
        if (this.formState.base) formData.append("base", toRaw(this.formState).base);
        formData.append("type_strategy", toRaw(this.formState).type_strategy);
        formData.append("type_assignment", toRaw(this.formState).type_assignment);
        // if (this.formState.queue) formData.append("channel_customer", channel_customer);
        if (this.formState.destination)
          formData.append("destination", toRaw(this.formState).destination);
        if (this.formState.template) {
          const dataKey =
            this.formState.type_strategy === StrategyType.sms ? "template_sms" : "template";
          formData.append(dataKey, toRaw(this.formState).template);
        }
        if (this.templateFile) formData.append("template_file", this.templateFile);
        if (this.formState.message) formData.append("message", this.formState.message);
        formData.append("file", this.file);
        if (this.formState.email_type === 2 && this.attachments) {
          // formData.append("attachments", toRaw(this.attachments));
          this.attachments.forEach((file) => {
            formData.append("attachments", file);
          });
        }
        if (this.formState.channel_customer)
          formData.append("channel_customer", toRaw(this.formState).channel_customer);
        if (this.formState.send_as_alias_identifier)
          formData.append("send_as_alias_identifier", toRaw(this.formState).send_as_alias_identifier);
        if (this.formState.subject) formData.append("subject", toRaw(this.formState).subject);
        if (this.formState.email_type)
          formData.append("email_type", toRaw(this.formState).email_type);
        if (this.formState.email_time)
          formData.append("email_time", toRaw(this.formState).email_time);
        if (this.formState.date) formData.append("date", toRaw(this.formState).date);
        if (this.formState.template_email)
          formData.append("template_email", toRaw(this.formState).template_email);
        if (this.formState.message) formData.append("message", toRaw(this.formState).message);
        if (
          this.formState.template_email ||
          (this.typeStrategy === 6 && this.formState.email_type === 2)
        ) {
          this.formState.destination = 1;
          formData.append("destination", toRaw(this.formState).destination);
        }
        if (this.formState.execution_time) {
          const fullDate = dayjs(this.formState.execution_time);
          formData.append("execution_time", fullDate.format("YYYY-MM-DD HH:mm:ss"));
        }

        if (this.formState.parameters_values?.length > 0) {
          formData.append("type_upload", toRaw(this.formState).type_upload);
          if (this.formState.type_upload == TypeCharge.PersonalizedParameters)
            formData.set(
              "parameter_values",
              JSON.stringify(this.formState.parameters_values
                .map(el => (
                  { 
                    id: el.id,
                    with_attribute: el.has_attribute,
                    attribute: el.attribute,
                    value: el.value,
                    name: el.name,
                    alternative_value: el.alternative_value 
                  }))
              )
            );
        }

        if (this.typeStrategy == TypeStrategy.Predictive) {
          formData.append("nc_regenerate", toRaw(this.formState?.nc_regenerate));
          this.formState?.nc_results_childrens.forEach((el) => {
            formData.append("nc_results", el);
          });
          formData.append("nc_rounds", toRaw(this.formState?.nc_rounds));
          formData.append("intensity_level", toRaw(this.formState?.intensity_level));
        }

        // Ivr con retorno + text to speech
        if ([TypeStrategy.IvrReturn, TypeStrategy.Ivr].includes(this.typeStrategy)) {
          formData.append("audio_config_type", this.formState.audio_config_type);

          if (this.formState.audio_config_type === "upload") {
            if (this.formState.audio_ivr_return) {
              formData.append("file_ivr", toRaw(this.formState).audio_ivr_return);
            }
          }

          if (this.formState.audio_config_type === "tts") {
            formData.append("is_tts", true);
            formData.set("type_upload", this.formState.type_upload);
            formData.append("tts_model", this.formState.tts_model);
            formData.append("tts_voice", this.formState.tts_voice_type);
            formData.append("tts_text", this.formState.tts_text);
            if (this.formState.audio_ivr_return) {
              formData.append("file_ivr", toRaw(this.formState).audio_ivr_return);
            }
            this.formState.tts_variables.forEach((variable) => {
              formData.append("variables", variable);
            });
          }
        }

        if (this.typeStrategy == TypeStrategy.IvrReturn) {
          if (this.formState.transfer_number)
            formData.append("transfer_number", toRaw(this.formState).transfer_number);
        }

        const autoCloseMinutes =
          this.formState.enable_auto_close && this.formState.auto_close_time
            ? this.formState.auto_close_time * 60
            : 0;
        formData.append("autoclose_ticket_minutes", autoCloseMinutes);

        this.generateByTemplate(formData);
      });
    },
    async generateByTemplate(data) {
      const isTts =
        [TypeStrategy.IvrReturn, TypeStrategy.Ivr].includes(this.typeStrategy) &&
        this.formState.audio_config_type === AudioConfigType.Tts;

      try {
        this.loading = true;
        this.ttsValidationProgress = 0;
        this.strategyGenerationProgress = 0;
        this.validatingTtsRecords = isTts;

        if (isTts) {
          const isTtsExcelValid = await this.validateTtsExcelBeforeGenerate();
          if (!isTtsExcelValid) return;

          this.ttsValidationProgress = 100;
          await new Promise(r => setTimeout(r, 300));
          this.validatingTtsRecords = false;
          this.generatingStrategy = true;
        }

        const response = await this.$store.dispatch("generateStrategyByTemplate",
          {
            data,
            onUploadProgress: (progressEvent) => {
              if (!progressEvent.total) return;
              const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              this.strategyGenerationProgress = Math.min(percent, 90);
            },
          }
        );

        this.strategyGenerationProgress = 100;
        await new Promise(r => setTimeout(r, 300));

        if (response.observation_sms) this.$message.warning(response.observation_sms);
        if (this.typeStrategy == TypeStrategy.Predictive)
          localStorage.setItem(
            "predictive_scheduled",
            JSON.stringify({
              name: this.formState.name,
              id: response.strategy.id,
              automatic: this.formState.execution_time ? true : false,
            })
          );
        this.$router.push("/strategies/");
      } catch (error) {
        console.log(error);

        if (error.response.data?.[0]?.code === LaunchErrorType.TierLimit) {
          Modal.error({
            title: () =>
              h("span", [
                "Plantillas disponibles insuficientes según tu ",
                h(
                  "a",
                  {
                    href: "https://developers.facebook.com/docs/whatsapp/messaging-limits/",
                    target: "_blank",
                  },
                  "TIER"
                ),
              ]),
            content:
              "No hemos podido generar la estrategia debido a que la cantidad de teléfonos identificados en tu importación supera el número de plantillas disponibles a enviar según tu Tier.",
            centered: true,
          });
          return;
        }

        const reponseError = error.response.data
          ? Object.values(error.response.data)?.join?.(",")
          : undefined;

        const errorMessage = error?.getErrorMessage?.() || reponseError || "Ha ocurrido un error";

        this.$message.error(errorMessage);
      } finally {
        this.loading = false;
        this.validatingTtsRecords = false;
        this.generatingStrategy = false;
        this.ttsValidationProgress = 0;
        this.strategyGenerationProgress = 0;
      }
    },
    async fetchEntities() {
      const data = await fetchAllEntities();
      this.entities = data.results;
    },
    async fetchPortfolios() {
      const response = await fetchPortfolios("", "", this.formState.entity);
      this.portfolios = response.results;
    },
    async fetchBases() {
      const response = await fetchAllBases(
        "",
        this.formState.entity,
        this.formState.portfolio,
        {},
        "1"
      );
      this.bases = response.results;

      if (!this.user?.customer.enable_bases) {
        this.formState.base = this.bases[0].id;
      }
    },

    handleEntityChange(value) {
      this.entity = value;

      this.formState.portfolio = undefined;
      this.formState.base = undefined;
      this.fetchPortfolios(value);
    },
    handleEmailTemplateChange() {
      const currentTemplate = this.currentEmailTemplate();
      this.displayEmailTemplate = currentTemplate.template;
    },
    handlePortfolioChange(value) {
      this.portfolio = value;
      this.portfolioName = this.portfolios.find((el) => el.id == value)?.name;
      this.formState.base = undefined;
      this.formState.channel_customer = undefined;
      this.formState.send_as_alias_identifier = null;
      this.selectedEmailOption = null;
      this.aliasesByIdentifier = {};
      this.fetchBases(value);
      this.fetchEmailIdentifiers(value);
      this.getEmailTemplates();
      // this.$store.dispatch("fetchTemplatesWhatsapp", value);
    },
    handleOpenRestrictionTTS() {
      this.restrictionSource = "tts";
      this.actionRestriction = ActionPlanStrategy.Upgrade;
      this.showAlertRestriction = false;
      this.planRequest = PlanType.AllInOne;
      this.openRestriction = true;
    },
    openUploadCriteria() {
      const strategyMenuOrder = {
        [TypeStrategy.Predictive]: 1,
        [TypeStrategy.Progressive]: 2,
        [TypeStrategy.Ivr]: 3,
        [TypeStrategy.IvrReturn]: 3,
        [TypeStrategy.Sms]: 4,
        [TypeStrategy.Whatsapp]: 5,
        [TypeStrategy.Email]: 6,
      }[this.typeStrategy];

      if (!strategyMenuOrder) return;

      EventBus.emit(OPEN_HELP_CENTER_EVENT, {
        scope: "tab_strategies",
        itemOrders: [strategyMenuOrder, 1],
      });
    },
    handleTypeStrategyChange(value) {
      this.planRequest = undefined;
      this.actionRestriction = null;
      this.restrictionSource = null;
      const itemSelected = this.strategyTypes.find(el => el.id == value);
      console.log(this.plan, 'this.plan');
      if (itemSelected && itemSelected?.action && this.plan != 5) {
        this.actionRestriction = itemSelected?.action;
        if (itemSelected.action == ActionPlanStrategy.Personalized)
          this.showAlertRestriction = true;
        else {
          this.showAlertRestriction = false;
          if (
            value == TypeStrategy.Predictive && this.plan == PlanType.Digital ||
            value == TypeStrategy.Ivr && this.plan == PlanType.Digital ||
            value == TypeStrategy.Progressive && this.plan == PlanType.Digital
          )
            this.planRequest = PlanType.AllInOne;
        }

        this.openRestriction = true;
      } else {
        this.typeStrategy = value;
        this.formState.strategy_category = value;
        this.formState.type_strategy = value === StrategyType.ivr ? undefined : value;
        this.formState.email_type = undefined;
        this.formState.email_time = undefined;
        this.seletedStrategy = true;
        this.emailTime = 0;
        this.predictiveTime = 0;
        this.formState.media = undefined;
        this.formState.parameters_values = [];
        this.formState.template = undefined;
        this.formState.template_email = undefined;
        this.formState.whatsapp_template = undefined;
        this.formState.attachments = undefined;
        this.formState.type_upload = TypeCharge.ChargeParameters;
        this.file = null;
        this.changeInput = false;
        this.templateFile = null;
        this.formState.email_type_send = undefined;
        this.formState.queue = undefined;
        this.formState.destination = undefined;
        this.formState.channel_customer = undefined;
        this.formState.send_as_alias_identifier = null;
        this.selectedEmailOption = null;
        this.aliasesByIdentifier = {};
        if(this.typeStrategy === TypeStrategy.Progressive) this.formState.type_assignment = undefined;
        this.formState.message_type = undefined;
        this.formState.audio_ivr_return = null;
        if (this.ttsAudioUrl) URL.revokeObjectURL(this.ttsAudioUrl);
        this.ttsAudioUrl = null;
        this.ttsLastGeneratedSignature = null;
        this.ttsLastGeneratedVariablesSignature = null;
        this.ttsNewVersionAvailable = false;
        this.resetTtsAttemptLimit();
        this.formState.tts_text = "";
        this.formState.tts_variables = [];
        this.formState.tts_generated_audio = null;
        this.formState.audio_config_type = AudioConfigType.Upload;
      }      
    },
    handleIvrTypeChange(value) {
      this.typeStrategy = value;
      this.formState.type_strategy = value;

      if (value !== StrategyType.ivrReturn) {
        this.formState.transfer_number = undefined;
      }
    },
    handleEmailTimeChange(value) {
      this.formState.execution_time = null;
      this.emailTime = value;
      if (value === 2) this.selectedScheduleTime = true;
    },
    handlePredictiveTimeChange(value) {
      this.predictiveTime = value;
      this.formState.execution_time = null;
    },
    handleEmailTypeChange(value) {
      this.file = null;
      this.emailType = value;
      this.openEmail = true;
      if (value == 2) this.template_email = null;
    },
    handleEmailOptionChange(val) {
      this.isEmailSuspended = false;
      this.formState.send_as_alias_identifier = null;

      if (!val) {
        this.formState.channel_customer = null;
        this.customChannelId = null;
        return;
      }

      if (val.startsWith('alias:')) {
        const parts = val.split(':');
        // alias:<channelId>:<aliasEmail> — email may contain ":" so rejoin from index 2
        const channelId = parseInt(parts[1]);
        const aliasEmail = parts.slice(2).join(':');
        this.formState.channel_customer = channelId;
        this.formState.send_as_alias_identifier = aliasEmail;
      } else {
        // id:<channelId>
        this.formState.channel_customer = parseInt(val.replace('id:', ''));
      }

      this.customChannelId = this.formState.channel_customer;

      const currentIdentifier = this.currentChannelCustomer();
      if (currentIdentifier?.email_suspended && this.typeStrategy === 6) {
        this.isEmailSuspended = true;
      }
    },
    async fetchQueues() {
      const response = await fetchQueues();
      // this.queues = response.filter((item) => {
      //   const queue = item.channels_customer.filter(
      //     (channel) => channel.channel.id == ChannelType.Whatsapp
      //   );
      //   return queue.length > 0;
      // });
      this.queues = response;
    },
    whatsappIdentifier(queue) {
      const whatsapp = queue.channels_customer.find(
        (channel) => channel.channel.id == ChannelType.Whatsapp
      );
      return "(+" + whatsapp.data_parameters.phone_number + ")";
    },
    async getTemplates() {
      this.formState.template = undefined;
      if (!this.formState.queue) return;
      this.templates = await fetchTemplates(toRaw(this.formState).queue, "", false);
    },
    async getEmailTemplates() {
      this.formState.template_email = undefined;
      if (!this.formState.email_type) return;
      this.emailTemplates = await fetchEmailTemplates(true, this.formState.portfolio);
    },
    async fetchEmailIdentifiers(portfolioId) {
      this.emailIdentifiers = await fetchAllChannelsCustomersByPortfolio(portfolioId);
      await this.preloadAliasesForAllIdentifiers();
    },
    async preloadAliasesForAllIdentifiers() {
      const identifiers = this.emailIdentifiers || [];
      const results = await Promise.allSettled(
        identifiers.map(async (item) => {
          const data = await fetchSendAsAliases(item.id);
          const list = Array.isArray(data) ? data : (data?.results || []);
          return { id: item.id, aliases: list };
        })
      );
      const aliasMap = {};
      for (const r of results) {
        if (r.status === 'fulfilled') {
          aliasMap[r.value.id] = r.value.aliases;
        }
      }
      this.aliasesByIdentifier = aliasMap;
    },
    getAliasesForChannel(channelCustomerId) {
      const list = [...(this.aliasesByIdentifier[channelCustomerId] || [])];
      const sendAsAlias = this.formState.send_as_alias_identifier;
      const channelCustomer = this.formState.channel_customer;
      
      if (channelCustomer === channelCustomerId && sendAsAlias) {
        const exists = list.some((alias) => alias.email === sendAsAlias);
        if (!exists) {
          list.push({
            id: -1,
            email: sendAsAlias,
          });
        }
      }
      return list;
    },
    async handleDownloadTemplate() {
      try {
        const data = {
          destination: this.formState.destination,
          template: this.formState.template,
        };
        if (this.currentTemplate?.parameters?.length > 0) {
          data.type_upload = this.formState.type_upload;
        }
        const blob = await downloadTemplateWhatsapp(data);
        downloadFile(blob, "plantilla_whatsapp.zip");
        this.$message.success("Se descargó “plantilla_whatsapp” correctamente");
      } catch (error) {
        this.$message.error("Seleccione una plantilla para descargar");
        console.error(error);
      }
    },
    async handleDownloadEmailTemplate() {
      try {
        const data = {
          destination: 1,
          template: this.formState.template_email,
        };
        if (this.currentEmailTemplate()?.parameters?.length > 0) {
          data.type_upload = this.formState.type_upload;
        }
        const blob = await downloadTemplateEmail(data);
        downloadFile(blob, "plantilla_correo.zip");
        this.$message.success("Se descargó “plantilla_correo” correctamente");
      } catch (error) {
        console.log(error, 'error');
        this.$message.error("Seleccione una plantilla para descargar");
      }
    },
    async handleDownloadSmsTemplate() {
      try {
        const data = {
          destination: this.formState.destination,
          template: this.formState.template,
        };
        if (this.currentTemplateSms?.parameters?.length > 0) {
          data.type_upload = this.formState.type_upload;
        }
        const blob = await smsTemplatesService.downloadExcelTemplate(data);
        downloadFile(blob, "plantilla_sms.zip", { useResponseFileName: true });
      } catch (error) {
        this.$message.error("Ocurrió un error en la descarga");
        console.error(error);
      }
    },
    handleChangeInput(able = true) {
      this.changeInput = able;
      this.ttsValidationReportResponse = null;
    },
    handleChangeOpenWhatsapp() {
      this.openWhatsapp = true;
    },
    handleChangeOpenSms() {
      this.openSms = true;
    },
    getTemplateTypeText(type) {
      let text = "";

      if (type === WhatsappTemplateTypes.Text) text = "Texto";
      if (type === WhatsappTemplateTypes.TextAndImage) text = "Texto e imagen";
      if (type === WhatsappTemplateTypes.TextAndVideo) text = "Texto y video";
      if (type === WhatsappTemplateTypes.TextAndDocument) text = "Texto y documento";

      return text;
    },
    scaleIframeContent() {
      const iframe = this.$refs.iframe;
      const scale = 0.7; // Escala el contenido al 80% de su tamaño original
      iframe.contentWindow.document.body.style.zoom = scale;
    },
    customLabel(template) {
      return (
        template?.name +
        " " +
        (template?.template_type
          ? ` - Tipo ${this.getTemplateTypeText(template?.template_type)}`
          : "")
      );
    },
    renderWheelSafeDropdown({ menuNode }) {
      return h(
        "div",
        {
          onWheel: this.stopDropdownWheel,
        },
        [menuNode]
      );
    },
    stopDropdownWheel(event) {
      event.stopPropagation();
    },
  },
});
</script>

<style lang="sass" scoped>
$height: calc(100vh - #{$header-height} - 26px)

.back-button
  width: fit-content
  padding: 0

.form
  height: 100%

.container
  min-width: 800px
  max-width: calc( 50% + 20px )
  height: 100%
  padding: 20px 20px 0 20px
  display: flex
  flex-direction: column

  &__title
    margin: 12px 0 0 0

  &__subtitle
    padding-bottom: 12px
    border-bottom: $border-normal

  &__body
    flex: auto
    margin: 12px 0
    padding-right: 16px

  &__footer
    padding: 12px 20px
    border-top: $border-normal

.icon-arrowleft
  margin-right: 8px
.container-file
  margin-right: 6px
.view-template
  position: absolute
  top: 0
  bottom: 0
  margin: auto
  padding: 0

.view-template-disabled
  display: flex
  align-items: center
  min-height: 100%
  cursor: not-allowed
  color: rgba(0, 0, 0, 0.25)

.select-info
  color: $gray-6

.card
  padding: 14px 12px 8px 12px
  margin: 12px 0
  border: 1px solid $gray-6
  border-radius: 8px

  h4
    font-weight: 600
    font-size: 14px
    margin-bottom: 12px

  &__action
    display: inline-flex
    align-items: center
    gap: 4px
    padding: 0
    flex-shrink: 0
    line-height: 22px

  &--light
    border: 1px solid #dcdcdc
    color: $gray-9
    background-color: rgba(0, 0, 0, 0.02)
    padding: 8px 12px
    margin: 4px 0 12px 0

    &.warning
      color: #FAAD14
      border-color: #FAAD14
      background-color: #FFFBE6
  &--error
    border: 1px solid $red-9
    background: $red-1
    padding: 8px 16px
    display: flex
    gap: 8px
    border-radius: 4px
    margin: 12px 0
    .error__text
      margin: 0

.info
  display: flex

  &--text
    font-size: 13px
    color: $gray-9

.download-header
  display: flex
  justify-content: space-between
  align-items: center
  margin-bottom: 10px

.container__empty
  margin: 0 auto
  border: 1px solid $gray-6
  border-radius: 8px
  height: 200px
  font-size: 12px
  color: #8C8C8C
  padding: 70px 0
  text-align: center

.message--info
  margin-bottom: 0

:deep(.container__archive > .picker > .picker__container)
  width: 100% !important
  height: 180px !important

.container__archive
  &-divider
    display: flex
    justify-content: space-between

:deep(.container__archive-divider > .picker)
  width: 49%
:deep(.container__archive-divider > .ant-btn)
  width: 49%
  height: 140px
  margin: 4px 0

.selected__destination
  margin: 0 auto
  border: 1px solid $gray-6
  border-radius: 8px
  height: 300px
  font-size: 12px
  color: #8C8C8C
  padding: 130px 0
  text-align: center

.info-popover-wrapper
  width: 225px
  color: $gray-8

.warning
  display: flex

  &__icon
    color: $orange-6
    margin-top: 1px
    font-size: 15px

  &__text
    font-size: 12px
    color: $gray-8
    margin-left: 4px
.email
  p
    padding-bottom: 15px

.template_detail
  font-weight: 400
  color: $gray-7
  font-style: italic

.number-transfer
  display: flex
  justify-items: left
  gap: 8px
  span
    margin-top: 6px
.required
  color: $red-7
  margin-right: 2px

.title__strong
  font-weight: 600

.auto-close
  &__header
    display: flex
    align-items: center
    gap: 8px

  &__description
    color: $gray-8
    font-size: 14px
    margin: 4px 0 12px 0
    strong
      font-weight: 600

  &__time
    display: flex
    align-items: center
    gap: 8px

  &__select
    width: 180px

  &__item
    :deep(.ant-form-item)
      margin-bottom: 16px !important
    :deep(.ant-row.ant-form-item-row)
      margin-bottom: 0 !important
.details
  color: #00000073
  margin-bottom: 10px

:global(.audio-tts-tooltip)
  min-width: 380px
  strong
    font-weight: 500

:global(.white-tooltip .ant-tooltip-inner)
  color: #000000A6 !important

/* Fondo blanco + borde y sombra suaves */
:global(.white-tooltip .ant-tooltip-inner)
  background: #fff
  color: #1f2937
  border: 1px solid #fff
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12)

/* Flecha del tooltip en blanco */
:global(.white-tooltip .ant-tooltip-arrow::before)
  background: #fff

/* Asegura que el overlay del select no recorte el tooltip */
:global(.ant-select-dropdown)
  overflow: visible

.info-help
  &__text
    color: #000000A6

.tts-toolbar
  display: flex
  justify-content: space-between
  align-items: center
  margin-top: 2px
  margin-bottom: 10px

  &__left
    display: flex
    align-items: center
    gap: 8px
    margin-top: 6px

  &__right
    color: #8c8c8c
    font-size: 13px
    display: flex
    align-items: center
    gap: 4px

.tts-footer
  display: flex
  justify-content: flex-end
  align-items: center
  gap: 20px
  margin-top: 0

  &__center,
  &__right
    display: flex
    align-items: center
    gap: 8px

  &__cost
    display: flex
    align-items: center
    gap: 6px
    color: $gray-9
    cursor: default

.tts-cost
  width: 260px

  h4
    margin: 0 0 12px
    font-size: 14px
    font-weight: 600

  &__row,
  &__total
    display: flex
    justify-content: space-between
    gap: 12px
    font-size: 12px

  &__row
    color: $gray-7
    margin-bottom: 8px

  &__total
    border-top: 1px solid $gray-5
    padding-top: 8px
    margin-top: 8px
    color: $gray-9

  p
    color: $gray-6
    font-size: 12px
    font-style: italic
    line-height: 1.6
    margin: 10px 0 0

.tts-strategy-cost
  margin-top: 18px

  h4
    font-size: 16px
    font-weight: 600
    margin-bottom: 12px

  :deep(.ant-alert)
    align-items: center
    padding: 16px 24px

  :deep(.ant-alert-message)
    color: $gray-9
    font-size: 15px
    line-height: 1.6

.tts-validation-report
  margin-top: 18px

  :deep(.ant-alert-message)
    display: flex
    align-items: center
    flex-wrap: wrap
    gap: 4px

  :deep(.ant-btn-link)
    height: auto
    padding: 0

.audio-text.ant-form-item
  margin-bottom: 0 !important

.tts-textarea
  position: relative

  &__preview
    position: absolute
    inset: 0
    z-index: 1
    min-height: 120px
    margin: 0
    padding: 4px 11px
    border: 1px solid transparent
    color: $gray-9
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif
    font-size: 14px
    font-weight: 400
    line-height: 1.5715
    letter-spacing: 0
    white-space: pre-wrap
    word-break: break-word
    pointer-events: none
    overflow: hidden

  &__variable
    padding: 0
    border-radius: 4px
    background-color: $gray-2
    color: $gray-9
    box-shadow: 0 0 0 0.5px $gray-7

    &--repited
      background-color: $red-1
      padding: 0 1px
      color: $red-5
      box-shadow: 0 0 0 0.5px $red-5

  &__variable-edit
    color: $gray-7
    &--repited
      color: $red-5


  :deep(.tts-textarea__input)
    position: relative
    z-index: 2
    font-size: 14px
    line-height: 1.5715
    letter-spacing: 0

  :deep(.tts-textarea__input--overlay)
    color: transparent
    caret-color: $gray-9
    background-color: transparent

  :deep(.tts-textarea__input::placeholder)
    color: $gray-6

.tts-variable-error
  color: $red-7

.audio-generated
  border-top: 1px solid $gray-5
  margin-top: 16px
  padding-top: 16px

:global(.tts-extra-attempt-popover)
  max-width: 340px

:global(.tts-extra-attempt-popover__content)
  h4
    color: $gray-9
    font-size: 16px
    font-weight: 600
    margin: 0 0 8px

  p
    color: $gray-8
    font-size: 14px
    line-height: 1.6
    margin: 0 0 8px

.option
  p
    font-size: 12px
    color: rgba(0, 0, 0, 0.45)
    margin: 0
</style>
<style>
.editor .ck-content {
  min-height: 150px;
}
.card--error span svg {
  color: #ff4d4f;
}

#template_email {
  width: 300px;
  height: 300px;
}

iframe img {
  width: 100px;
}

#template_email img {
  width: 100px;
}
</style>
